export default {
	// 서울 종로
	"2110101" : [
		{
			"requester": "",
			"research": "입소스",
			"period": "3월 10일 ~ 3월 11일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 50.5},
				{party: "unitedfuture", name : "황교안", ratio: 30.2},
				{party: "minsaengdang", name : "한병영", ratio: 0.8},
				{party: "minjung", name : "오인환", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 15.3},
			]
		},
		{
			"requester": "",
			"research": "코리아리서치인터내셔널",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 52.6},
				{party: "unitedfuture", name : "황교안", ratio: 32.6},
				{party: "minsaengdang", name : "한병영", ratio: 3.5},
				{party: "undecided", name : "-", ratio: 8.4},
			]
		},
		{
			"requester": "",
			"research": "리서치앤리서치",
			"period": "3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 55.3},
				{party: "unitedfuture", name : "황교안", ratio: 30.6},
				{party: "undecided", name : "-", ratio: 13.6},
			]
		},
		{
			"requester": "",
			"research": "엠브레인퍼블릭",
			"period": "3월 20일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 52.3},
				{party: "unitedfuture", name : "황교안", ratio: 29.3},
				{party: "minsaengdang", name : "한병영", ratio: 0.7},
				{party: "minjung", name : "오인환", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 16.5},
			]
		},
		{
			"requester": "",
			"research": "모노커뮤니케이션즈",
			"period": "3월 23일 ~ 3월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 48.5},
				{party: "unitedfuture", name : "황교안", ratio: 36.6},
				{party: "minsaengdang", name : "한병영", ratio: 1.1},
				{party: "minjung", name : "오인환", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 9.1},
			]
		},
		{
			"requester": "",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 57.2},
				{party: "unitedfuture", name : "황교안", ratio: 33.8},
				{party: "minsaengdang", name : "한병영", ratio: 0.9},
				{party: "ourrepublican", name : "한민호", ratio: 2.1},
				{party: "minjung", name : "오인환", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 4.6},
			]
		},
		{
			"requester": "",
			"research": "메트릭스리서치",
			"period": "3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 48.3},
				{party: "unitedfuture", name : "황교안", ratio: 35.0},
				{party: "undecided", name : "-", ratio: 16.1},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 55.1},
				{party: "unitedfuture", name : "황교안", ratio: 34.5},
				{party: "ourrepublican", name : "한민호", ratio: 0.6},
				{party: "minjung", name : "오인환", ratio: 0.2},
				{party: "ourrepublican", name : "신동욱", ratio: 0.2},
				{party: "minjung", name : "박소현", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 8.2},
			]
		},
		{
			"requester": "미래한국연구소, VOK",
			"research": "피플네트웍스",
			"period": "3월 31일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 51.0},
				{party: "unitedfuture", name : "황교안", ratio: 39.0},
				{party: "ourrepublican", name : "한민호", ratio: 1.6},
				{party: "minjung", name : "오인환", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 5.4},
			]
		},
		{
			"requester": "CBS, 국민일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 52.2},
				{party: "unitedfuture", name : "황교안", ratio: 37.1},
				{party: "ourrepublican", name : "한민호", ratio: 1.8},
				{party: "minjung", name : "오인환", ratio: 2.3},
				{party: "undecided", name : "-", ratio: 4.4},
			]
		},
		{
			"requester": "문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 53.0},
				{party: "unitedfuture", name : "황교안", ratio: 27.5},
				{party: "ourrepublican", name : "한민호", ratio: 1.1},
				{party: "minjung", name : "오인환", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 16.4},
			]
		},
		{
			"requester": "서울신문",
			"research": "리서치앤리서치",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 51.1},
				{party: "unitedfuture", name : "황교안", ratio: 36.9},
				{party: "ourrepublican", name : "한민호", ratio: 0.3},
				{party: "minjung", name : "오인환", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 10.5},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 63.5},
				{party: "unitedfuture", name : "황교안", ratio: 26.7},
				{party: "ourrepublican", name : "한민호", ratio: 0.9},
				{party: "minjung", name : "오인환", ratio: 0.4},
				{party: "etcparty", name : "이정희", ratio: 0.4},
				{party: "etcparty", name : "박준영", ratio: 0.2},
				{party: "etcparty", name : "양세화", ratio: 0.4},
				{party: "etcparty", name : "김형석", ratio: 0.6},
				{party: "noparty", name : "김용덕", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 6.4},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 59.4},
				{party: "unitedfuture", name : "황교안", ratio: 28.8},
				{party: "ourrepublican", name : "한민호", ratio: 0.9},
				{party: "minjung", name : "오인환", ratio: 0.2},
				{party: "etcparty", name : "이정희", ratio: 0},
				{party: "etcparty", name : "신동욱", ratio: 0},
				{party: "etcparty", name : "박준영", ratio: 0.8},
				{party: "etcparty", name : "백병찬", ratio: 0},
				{party: "etcparty", name : "양세화", ratio: 0.2},
				{party: "etcparty", name : "박소현", ratio: 0.2},
				{party: "noparty", name : "김형석", ratio: 0.9},
				{party: "noparty", name : "김용덕", ratio: 0},
				{party: "undecided", name : "-", ratio: 8.7},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 58.4},
				{party: "unitedfuture", name : "황교안", ratio: 30.1},
				{party: "ourrepublican", name : "한민호", ratio: 0.5},
				{party: "minjung", name : "오인환", ratio: 0.4},
				{party: "etcparty", name : "이정희", ratio: 0.2},
				// {party: "etcparty", name : "신동욱", ratio: 0},
				{party: "etcparty", name : "박준영", ratio: 0.2},
				// {party: "etcparty", name : "백병찬", ratio: 0},
				{party: "etcparty", name : "양세화", ratio: 0.2},
				{party: "etcparty", name : "박소현", ratio: 0.3},
				{party: "noparty", name : "김형석", ratio: 0.9},
				{party: "noparty", name : "김용덕", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이낙연", ratio: 52.9},
				{party: "unitedfuture", name : "황교안", ratio: 29.9},
				{party: "ourrepublican", name : "한민호", ratio: 3.0},
				{party: "minjung", name : "오인환", ratio: 0.3},
				// {party: "etcparty", name : "이정희", ratio: 0},
				// {party: "etcparty", name : "신동욱", ratio: 0},
				// {party: "etcparty", name : "박준영", ratio: 0.8},
				// {party: "etcparty", name : "백병찬", ratio: 0},
				// {party: "etcparty", name : "양세화", ratio: 0.2},
				// {party: "etcparty", name : "박소현", ratio: 0.2},
				// {party: "noparty", name : "김형석", ratio: 0.9},
				// {party: "noparty", name : "김용덕", ratio: 0},
				{party: "undecided", name : "-", ratio: 13.3},
			]
		},
	],
	// 서울 중구성동갑
	"2110402" : [
	],
	// 서울 중구성동을
	"2110201" : [
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "박성준", ratio: 42.0},
				{party: "unitedfuture", name : "지상욱", ratio: 40.9},
				{party: "undecided", name : "-", ratio: 16.2},
			]
		},
	],
	// 서울 용산
	"2110301" : [
	],
	// 서울 광진갑
	"2110501" : [
	],
	// 서울 광진을
	"2110502" : [
		{
			"requester": "",
			"research": "입소스",
			"period": "3월 10일 ~ 3월 11일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 44.5},
				{party: "unitedfuture", name : "오세훈", ratio: 36.8},
				{party: "undecided", name : "-", ratio: 14.1},
			]
		},
		{
			"requester": "",
			"research": "한국리서치",
			"period": "3월 12일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 43.3},
				{party: "unitedfuture", name : "오세훈", ratio: 32.3},
				{party: "undecided", name : "-", ratio: 17.2},
			]
		},
		{
			"requester": "",
			"research": "코리아리서치인터내셔널",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 41.7},
				{party: "unitedfuture", name : "오세훈", ratio: 39.8},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "",
			"research": "리서치앤리서치 ",
			"period": "3월 17일 ~ 3월 18일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 43.2},
				{party: "unitedfuture", name : "오세훈", ratio: 40.7},
				{party: "undecided", name : "-", ratio: 15.4},
			]
		},
		{
			"requester": "",
			"research": "엠브레인퍼블릭",
			"period": "3월 20일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 40.9},
				{party: "unitedfuture", name : "오세훈", ratio: 36.6},
				{party: "undecided", name : "-", ratio: 18.4},
			]
		},
		{
			"requester": "",
			"research": "모노커뮤니케이션즈",
			"period": "3월 23일 ~ 3월 23일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 43.3},
				{party: "unitedfuture", name : "오세훈", ratio: 43.9},
				{party: "undecided", name : "-", ratio: 10.5},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 47.1},
				{party: "unitedfuture", name : "오세훈", ratio: 38.4},
				{party: "etcparty", name : "허정연", ratio: 1.5},
				{party: "etcparty", name : "오태양", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "",
			"research": "리얼미터",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 47.1},
				{party: "unitedfuture", name : "오세훈", ratio: 43.3},
				{party: "undecided", name : "-", ratio: 8.1},
			]
		},
		{
			"requester": "서울신문",
			"research": "리서치앤리서치",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 45.7},
				{party: "unitedfuture", name : "오세훈", ratio: 37.7},
				{party: "etcparty", name : "허정연", ratio: 0.7},
				{party: "etcparty", name : "오태양", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 14.8},
			]
		},
		{
			"requester": "JTBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "고민정", ratio: 49.6},
				{party: "unitedfuture", name : "오세훈", ratio: 39.4},
				// {party: "etcparty", name : "허정연", ratio: 0.7},
				// {party: "etcparty", name : "오태양", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 9.8},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
						{party: "theminjoo", name : "고민정", ratio: 50.9},
						{party: "unitedfuture", name : "오세훈", ratio: 40.1},
				// 		// {party: "etcparty", name : "허정연", ratio: 0.7},
				// 		// {party: "etcparty", name : "오태양", ratio: 1.1},
						{party: "undecided", name : "-", ratio: 7.9},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
						{party: "theminjoo", name : "고민정", ratio: 47.7},
						{party: "unitedfuture", name : "오세훈", ratio: 43.0},
						// {party: "etcparty", name : "허정연", ratio: 0.7},
						{party: "etcparty", name : "오태양", ratio: 1.0},
						{party: "undecided", name : "-", ratio: 8.3},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
						{party: "theminjoo", name : "고민정", ratio: 48.1},
						{party: "unitedfuture", name : "오세훈", ratio: 41.3},
						{party: "etcparty", name : "허정연", ratio: 0.6},
						{party: "etcparty", name : "오태양", ratio: 1.4},
						{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
						{party: "theminjoo", name : "고민정", ratio: 48.1},
						{party: "unitedfuture", name : "오세훈", ratio: 35.1},
				// 		// {party: "etcparty", name : "허정연", ratio: 0.7},
				// 		// {party: "etcparty", name : "오태양", ratio: 1.1},
						{party: "undecided", name : "-", ratio: 12.9},
			]
		},
	],
	// 서울 동대문갑
	"2110601" : [
	],
	// 서울 동대문을
	"2110602" : [
		{
			"requester": "",
			"research": "한국리서치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "장경태", ratio: 35.7},
				{party: "unitedfuture", name : "이혜훈", ratio: 32.2},
				{party: "minjung", name : "김종민", ratio: 1.42},
				{party: "etcparty", name : "박경희", ratio: 0.6},
				{party: "noparty", name : "민병두", ratio: 17.7},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 500,
			desc: "95% 신뢰수준에서 ±4.4%p",
			link: "https://datanews.sbs.co.kr/pds/202004/%5B%ED%86%B5%EA%B3%84%ED%91%9C%5D%202020%20SBS%20%EC%B4%9D%EC%84%A0%201%EC%B0%A8%20%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC_%EC%84%9C%EC%9A%B8%20%EB%8F%99%EB%8C%80%EB%AC%B8%EA%B5%AC%EC%9D%84.pdf",
			data: [
				{party: "theminjoo", name : "장경태", ratio: 31.3},
				{party: "unitedfuture", name : "이혜훈", ratio: 28.3},
				{party: "minjung", name : "김종민", ratio: 1.4},
				{party: "etcparty", name : "박경희", ratio: 1.0},
				{party: "noparty", name : "민병두", ratio: 24.8},
			]
		},
		{
			"requester": "CBS, 국민일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "장경태", ratio: 39.3},
				{party: "unitedfuture", name : "이혜훈", ratio: 33.5},
				{party: "minjung", name : "김종민", ratio: 2.1},
				{party: "noparty", name : "민병두", ratio: 13.2},
				{party: "undecided", name : "-", ratio: 9.3},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "장경태", ratio: 43.0},
				{party: "unitedfuture", name : "이혜훈", ratio: 31.0},
				{party: "minjung", name : "김종민", ratio: 1.5},
				{party: "etcparty", name : "박경희", ratio: 2.0},
				{party: "noparty", name : "민병두", ratio: 15.6},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
	],
	// 서울 중랑갑
	"2110701" : [
	],
	// 서울 중랑을
	"2110702" : [
	],
	// 서울 성북갑
	"2110801" : [
	],
	// 서울 성북을
	"2110802" : [
	],
	// 서울 강북갑
	"2110901" : [
	],
	// 서울 강북을
	"2110902" : [
	],
	// 서울 도봉갑
	"2111001" : [
	],
	// 서울 도봉을
	"2111002" : [
	],
	// 서울 노원갑
	"2111101" : [
	],
	// 서울 노원을
	"2111102" : [
	],
	// 서울 노원병
	"2111103" : [
	],
	// 서울 은평갑
	"2111201" : [
	],
	// 서울 은평을
	"2111202" : [
	],
	// 서울 서대문갑
	"2111301" : [
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 504,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "우상호", ratio: 48.7},
				{party: "unitedfuture", name : "이성헌", ratio: 31.4},
				{party: "ourrepublican", name : "신민호", ratio: 0.4},
				{party: "minjung", name : "전진희", ratio: 1.1},
				{party: "noparty", name : "신지애", ratio: 5.8},
				{party: "undecided", name : "-", ratio: 12.3},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "우상호", ratio: 48.4},
				{party: "unitedfuture", name : "이성헌", ratio: 32.0},
				{party: "undecided", name : "-", ratio: 13.7},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "우상호", ratio: 51.8},
				{party: "unitedfuture", name : "이성헌", ratio: 33.7},
				{party: "ourrepublican", name : "신민호", ratio: 1.3},
				{party: "minjung", name : "전진희", ratio: 1.0},
				{party: "noparty", name : "신지애", ratio: 5.0},
				{party: "undecided", name : "-", ratio: 6.2},
			]
		},
	],
	// 서울 서대문을
	"2111302" : [
	],
	// 서울 마포갑
	"2111401" : [
	],
	// 서울 마포을
	"2111402" : [
	],
	// 서울 양천갑
	"2111501" : [
	],
	// 서울 양천을
	"2111502" : [
		{
			"requester": "뉴스토마트",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이용선", ratio: 50.7},
				{party: "unitedfuture", name : "손영택", ratio: 35.7},
				{party: "ourrepublican", name : "박칠성", ratio: 1.4},
				{party: "etcparty", name : "김명시", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 11.0},
			]
		},
	],
	// 서울 강서갑
	"2111601" : [
	],
	// 서울 강서을
	"2111602" : [
		{
			"requester": "",
			"research": "입소스 ",
			"period": "3월 11일 ~ 3월 12일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "진성준", ratio: 49.0},
				{party: "unitedfuture", name : "김태우", ratio: 25.9},
				{party: "ourrepublican", name : "박혜영", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 20.6},
			]
		},
	],
	// 서울 강서병
	"2111603" : [
	],
	// 서울 구로갑
	"2111701" : [
	],
	// 서울 구로을
	"2111702" : [
		{
			"requester": "",
			"research": "입소스",
			"period": "3월 11일 ~ 3월 12일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 45.4},
				{party: "unitedfuture", name : "김용태", ratio: 23.4},
				{party: "ourrepublican", name : "오세찬", ratio: 3.7},
				{party: "undecided", name : "-", ratio: 24.1},
			]
		},
		{
			"requester": "",
			"research": "엠브레인퍼블릭",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 40.9},
				{party: "unitedfuture", name : "김용태", ratio: 22.9},
				{party: "undecided", name : "-", ratio: 29.0},
			]
		},
		{
			"requester": "",
			"research": "리서치앤리서치 ",
			"period": "3월 22일 ~ 3월 23일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 43.3},
				{party: "unitedfuture", name : "김용태", ratio: 28.7},
				{party: "undecided", name : "-", ratio: 25.7},
			]
		},
		{
			"requester": "시사저널",
			"research": "모노리서치",
			"period": "3월 23일 ~ 3월 24일",
			"respondent": 509,
			desc: "시사저널이 여론조사기관 모노리서치에 의뢰해 서울 종로와 광진을, 구로을 등 3개 지역에서 해당 지역 거주 만 18세 이상 남녀를 대상으로 3월23~24일 양일에 걸쳐 진행했다. 조사방법은 유·무선 전화 ARS 및 전화면접 조사를 병행했다. 구로을은 509명을 대상으로 유선전화 조사 131건, 무선전화 조사 378건이었다. 인구비례할당 무작위 추출에 의한 유선전화 RDD(25.7%)와 SK·KT·LGU+로부터 무작위 추출로 제공받은 가상번호(74.3%)로 표본추출했다. 응답률은 3.5%이고 95% 신뢰 수준에서 표본오차는 ±4.3%포인트다. 가중값 산출 및 적용방법은 2020년 2월말 행정안전부 주민등록 인구 기준 성별·연령별·지역별로 가중값을 부여했으며 셀 가중 방식을 사용",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=586&aid=0000012611",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 46.8},
				{party: "unitedfuture", name : "김용태", ratio: 28.8},
				{party: "ourrepublican", name : "오세찬", ratio: 4.6},
				{party: "undecided", name : "-", ratio: 15.0},
			]
		},
		{
			"requester": "",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 48.3},
				{party: "unitedfuture", name : "김용태", ratio: 30.2},
				{party: "ourrepublican", name : "오세찬", ratio: 3.8},
				{party: "undecided", name : "-", ratio: 13.6},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 45.7},
				{party: "unitedfuture", name : "김용태", ratio: 31.2},
				{party: "ourrepublican", name : "오세찬", ratio: 8.6},
				{party: "undecided", name : "-", ratio: 14.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 50.1},
				{party: "unitedfuture", name : "김용태", ratio: 27.7},
				{party: "ourrepublican", name : "오세찬", ratio: 2.2},
				{party: "noparty", name : "강요식", ratio: 7.3},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
		{
			"requester": "CBS, 국민일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "윤건영", ratio: 42.5},
				{party: "unitedfuture", name : "김용태", ratio: 37.5},
				{party: "noparty", name : "강요식", ratio: 11.0},
				{party: "undecided", name : "-", ratio: 8.1},
			]
		},
	],
	// 서울 금천
	"2111801" : [
		{
			"requester": "",
			"research": "한길리서치센타",
			"period": "3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "최기상", ratio: 37.9},
				{party: "unitedfuture", name : "강성만", ratio: 22.9},
				{party: "noparty", name : "차성수", ratio: 18.4},
				{party: "undecided", name : "-", ratio: 17.7},
			]
		},
		{
			"requester": "",
			"research": "한국사회여론연구소 ",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "최기상", ratio: 36.5},
				{party: "unitedfuture", name : "강성만", ratio: 27.9},
				{party: "etcparty", name : "박창래", ratio: 3.5},
				{party: "noparty", name : "차성수", ratio: 13.5},
				{party: "undecided", name : "-", ratio: 18.6},
			]
		},
	],
	// 서울 영등포갑
	"2111901" : [
	],
	// 서울 영등포을
	"2111902" : [
		{
			"requester": "새로운한국을위한국민운동 서경석대표",
			"research": "모노커뮤니케이션즈(모노리서치)",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "김민석", ratio: 44.8},
				{party: "unitedfuture", name : "박용찬", ratio: 26.8},
				{party: "minsaengdang", name : "김지향", ratio: 1.8},
				{party: "etcparty", name : "이상륜", ratio: 1.8},
				{party: "noparty", name : "이정현", ratio: 6.2},
				{party: "undecided", name : "-", ratio: 18.6},
			]
		},
	],
	// 서울 동작갑
	"2112001" : [
	],
	// 서울 동작을
	"2112002" : [
		{
			"requester": "",
			"research": "한국리서치",
			"period": "3월 12일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 37.3},
				{party: "unitedfuture", name : "나경원", ratio: 33.9},
				{party: "undecided", name : "-", ratio: 19.6},
			]
		},
		{
			"requester": "",
			"research": "입소스 ",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 36.2},
				{party: "unitedfuture", name : "나경원", ratio: 36.6},
				{party: "justice21", name : "이호영", ratio: 5.4},
				{party: "ourrepublican", name : "이성우", ratio: 0.8},
				{party: "minjung", name : "최서현", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 17.3},
			]
		},
		{
			"requester": "",
			"research": "리얼미터",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 43.0},
				{party: "unitedfuture", name : "나경원", ratio: 40.2},
				{party: "justice21", name : "이호영", ratio: 5.5},
				{party: "ourrepublican", name : "이성우", ratio: 1.6},
				{party: "minjung", name : "최서현", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 6.2},
			]
		},
		{
			"requester": "",
			"research": "한국갤럽조사연구소",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 44.9},
				{party: "unitedfuture", name : "나경원", ratio: 34.3},
				{party: "justice21", name : "이호영", ratio: 4.2},
				{party: "minjung", name : "최서현", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 14.9},
			]
		},
		{
			"requester": "",
			"research": "리서치앤리서치",
			"period": "3월 17일 ~ 3월 18일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 47.1},
				{party: "unitedfuture", name : "나경원", ratio: 35.4},
				{party: "undecided", name : "-", ratio: 16.7},
			]
		},
		{
			"requester": "",
			"research": "엠브레인퍼블릭",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 44.0},
				{party: "unitedfuture", name : "나경원", ratio: 34.9},
				{party: "justice21", name : "이호영", ratio: 1.9},
				{party: "ourrepublican", name : "이성우", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 18.0},
			]
		},
		{
			"requester": "",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 50.4},
				{party: "unitedfuture", name : "나경원", ratio: 38.6},
				{party: "justice21", name : "이호영", ratio: 2.4},
				{party: "ourrepublican", name : "이성우", ratio: 0.6},
				{party: "minjung", name : "최서현", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 6.6},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 46.5},
				{party: "unitedfuture", name : "나경원", ratio: 36.9},
				{party: "justice21", name : "이호영", ratio: 1.8},
				{party: "ourrepublican", name : "이성우", ratio: 1.0},
				{party: "minjung", name : "최서현", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 12.4},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 503,
			desc: "표본오차 : 95% 신뢰 수준, ±4.4%p",
			link: "https://imnews.imbc.com/replay/2020/nwdesk/article/5688899_32524.html",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 48.5},
				{party: "unitedfuture", name : "나경원", ratio: 36.6},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
		{
			"requester": "",
			"research": "메트릭스리서치 ",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 46.4},
				{party: "unitedfuture", name : "나경원", ratio: 41.6},
				{party: "justice21", name : "이호영", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "CBS, 국민일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 40.9},
				{party: "unitedfuture", name : "나경원", ratio: 44.1},
				{party: "justice21", name : "이호영", ratio: 2.7},
				{party: "ourrepublican", name : "오세찬", ratio: 2.7},
				{party: "minjung", name : "최서현", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 5.8},
			]
		},
		{
			"requester": "문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 47.2},
				{party: "unitedfuture", name : "나경원", ratio: 34.3},
				{party: "justice21", name : "이호영", ratio: 1.8},
				{party: "ourrepublican", name : "오세찬", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 15.4},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 45.3},
				{party: "unitedfuture", name : "나경원", ratio: 42.8},
				// {party: "justice21", name : "이호영", ratio: 1.8},
				// {party: "ourrepublican", name : "오세찬", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 9.3},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 48.0},
				{party: "unitedfuture", name : "나경원", ratio: 35.5},
				{party: "justice21", name : "이호영", ratio: 1.3},
				{party: "ourrepublican", name : "오세찬", ratio: 0.5},
				{party: "minjung", name : "최서현", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 13.0},
			]
		},
		{
			"requester": "뉴스토마토",
			"research": "한국사회여론연구소",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 48.4},
				{party: "unitedfuture", name : "나경원", ratio: 42.1},
				{party: "justice21", name : "이호영", ratio: 1.4},
				{party: "ourrepublican", name : "오세찬", ratio: 0.3},
				{party: "minjung", name : "최서현", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 5.2},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 52.9},
				{party: "unitedfuture", name : "나경원", ratio: 36.6},
				{party: "justice21", name : "이호영", ratio: 2.0},
				{party: "ourrepublican", name : "오세찬", ratio: 0.6},
				{party: "minjung", name : "최서현", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 6.9},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "이수진", ratio: 53.6},
				{party: "unitedfuture", name : "나경원", ratio: 37.9},
				{party: "justice21", name : "이호영", ratio: 2.0},
				{party: "ourrepublican", name : "오세찬", ratio: 0.2},
				{party: "minjung", name : "최서현", ratio: 0.5},
				// {party: "etcparty", name : "조현숙", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 5.9},
			]
		},
	],
	// 서울 관악갑
	"2112101" : [
	],
	// 서울 관악을
	"2112102" : [
		{
			"requester": "뉴스토마토",
			"research": "한국사회여론연구소",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "정태호", ratio: 53.1},
				{party: "unitedfuture", name : "오신환", ratio: 32.5},
				// {party: "justice21", name : "김한영", ratio: 1.4},
				// {party: "ourrepublican", name : "오세찬", ratio: 0.3},
				{party: "minjung", name : "김한영", ratio: 2.1},
				// {party: "etcparty", name : "조현숙", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 8.0},
			]
		},
	],
	// 서울 서초갑
	"2112201" : [
	],
	// 서울 서초을
	"2112202" : [
	],
	// 서울 강남갑
	"2112301" : [
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 503,
			desc: "이번 조사는 중앙일보가 입소스에 의뢰해 서울 종로·광진을·동작을·서대문갑·강남갑에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(80~83% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 종로와 광진을, 동작을은 27~28일 각각 500명씩, 서대문갑은 26~27일 504명, 강남갑은 26~27일 503명을 조사했고 유·무선 평균 응답률은 지역별로 9.4~12.8%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=025&aid=0002988507",
			data: [
				{party: "theminjoo", name : "김성곤", ratio: 33.7},
				{party: "unitedfuture", name : "태구민", ratio: 42.6},
				{party: "minsaengdang", name : "정동희", ratio: 1.5},
				{party: "ourrepublican", name : "최혜림", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 19.3},
			]
		},
		{
			"requester": "뉴시스",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "김성곤", ratio: 36.8},
				{party: "unitedfuture", name : "태구민", ratio: 52.3},
				{party: "minsaengdang", name : "정동희", ratio: 1.9},
				{party: "etcparty", name : "김정훈", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 7.2},
			]
		},
	],
	// 서울 강남을
	"2112302" : [
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "전현희", ratio: 44.8},
				{party: "unitedfuture", name : "박진", ratio: 40.7},
				{party: "minsaengdang", name : "김광종", ratio: 1.7},
				{party: "etcparty", name : "강기현", ratio: 1.5},
				{party: "noparty", name : "김민찬", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
	],
	// 서울 강남병
	"2112303" : [
	],
	// 서울 송파갑
	"2112401" : [
	],
	// 서울 송파을
	"2112402" : [
		{
			"requester": "중앙일보",
			"research": "입소스 ",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "최재성", ratio: 37.5},
				{party: "unitedfuture", name : "배현진", ratio: 40.3},
				{party: "minsaengdang", name : "송동섭", ratio: 0.4},
				{party: "justice21", name : "한숙현", ratio: 2.3},
				{party: "ourrepublican", name : "권주", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 16.4},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "최재성", ratio: 43.0},
				{party: "unitedfuture", name : "배현진", ratio: 41.0},
				// {party: "minsaengdang", name : "송동섭", ratio: 4.9},
				{party: "justice21", name : "한숙현", ratio: 4.9},
				{party: "ourrepublican", name : "권주", ratio: 0.2},
				{party: "minjung", name : "김영신", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 10.2},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C",
			data: [
				{party: "theminjoo", name : "최재성", ratio: 36.1},
				{party: "unitedfuture", name : "배현진", ratio: 42.5},
				// {party: "minsaengdang", name : "송동섭", ratio: 4.9},
				{party: "justice21", name : "한숙현", ratio: 2.8},
				// {party: "ourrepublican", name : "권주", ratio: 0.2},
				// {party: "minjung", name : "김영신", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 17.5},
			]
		},
	],
	// 서울 송파병
	"2112403" : [
	],
	// 서울 강동갑
	"2112501" : [
		{
			"requester": "로이슈",
			"research": "데일리리서치",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "진선미", ratio: 41.0},
				{party: "unitedfuture", name : "이수희", ratio: 47.5},
				{party: "etcparty", name : "강옥기", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
	],
	// 서울 강동을
	"2112502" : [
	],
	// 부산 중구영도구
	"2260401" : [
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김비오", ratio: 45.8},
				{party: "unitedfuture", name : "황보승희", ratio: 43.4},
				// {party: "etcparty", name : "김가은", ratio: 11.2},
				// {party: "noparty", name : "정창범", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 7.8},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김비오", ratio: 42.2},
				{party: "unitedfuture", name : "황보승희", ratio: 43.5},
				// {party: "etcparty", name : "김가은", ratio: 11.2},
				// {party: "noparty", name : "정창범", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 8.7},
			]
		},
	],
	// 부산 서구동구
	"2260201" : [
		{
			"requester": "아시아투데이",
			"research": "알앤써치",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이재강", ratio: 37.3},
				{party: "unitedfuture", name : "안병길", ratio: 48.7},
				// {party: "ourrepublican", name : "김태수", ratio: 11.2},
				// {party: "etcparty", name : "김성기", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
	],
	// 부산 부산진갑
	"2260501" : [
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 35.3},
				{party: "unitedfuture", name : "서병수", ratio: 38.8},
				{party: "noparty", name : "정근", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
		{
			"requester": "MBN, 매일경제신문사",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 40.9},
				{party: "unitedfuture", name : "서병수", ratio: 39.0},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 35.3},
				{party: "unitedfuture", name : "서병수", ratio: 38.8},
				{party: "minsaengdang", name : "정해정", ratio: 0.4},
				{party: "noparty", name : "정근", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 32.9},
				{party: "unitedfuture", name : "서병수", ratio: 41.1},
				{party: "noparty", name : "정근", ratio: 14.9},
				{party: "undecided", name : "-", ratio: 8.4},
			]
		},
		{
			"requester": "",
			"research": "싸이리서치(SAI)",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 37.9},
				{party: "unitedfuture", name : "서병수", ratio: 36.8},
				{party: "minsaengdang", name : "정해정", ratio: 3.3},
				{party: "noparty", name : "정근", ratio: 8.4},
				{party: "undecided", name : "-", ratio: 11.3},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "3월 31일 ~ 4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 38.9},
				{party: "unitedfuture", name : "서병수", ratio: 35.9},
				{party: "minsaengdang", name : "정해정", ratio: 0.7},
				{party: "noparty", name : "정근", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 12.6},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 39.5},
				{party: "unitedfuture", name : "서병수", ratio: 36.9},
				{party: "noparty", name : "정근", ratio: 11.2},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 43.7},
				{party: "unitedfuture", name : "서병수", ratio: 35.4},
				{party: "minsaengdang", name : "정해정", ratio: 1.0},
				{party: "etcparty", name : "김정희", ratio: 0.5},
				{party: "noparty", name : "정근", ratio: 10.4},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
		{
			"requester": "국민일보, CBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 44.5},
				{party: "unitedfuture", name : "서병수", ratio: 36.2},
				{party: "minsaengdang", name : "정해정", ratio: 2.9},
				{party: "noparty", name : "정근", ratio: 9.3},
				{party: "undecided", name : "-", ratio: 6.0},
			]
		},
		{
			"requester": "TBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 39.1},
				{party: "unitedfuture", name : "서병수", ratio: 36.8},
				{party: "noparty", name : "정근", ratio: 9.1},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 40.5},
				{party: "unitedfuture", name : "서병수", ratio: 44.7},
				{party: "minsaengdang", name : "정해정", ratio: 0.6},
				{party: "etcparty", name : "김정희", ratio: 1.9},
				{party: "noparty", name : "정근", ratio: 7.6},
				{party: "undecided", name : "-", ratio: 4.7},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 38.5},
				{party: "unitedfuture", name : "서병수", ratio: 34.7},
				{party: "minsaengdang", name : "정해정", ratio: 0.4},
				// {party: "etcparty", name : "김정희", ratio: 0.5},
				{party: "noparty", name : "정근", ratio: 9.4},
				{party: "undecided", name : "-", ratio: 15.8},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 39.2},
				{party: "unitedfuture", name : "서병수", ratio: 44.2},
				{party: "minsaengdang", name : "정해정", ratio: 9.4},
				// {party: "etcparty", name : "김정희", ratio: 0.5},
				{party: "noparty", name : "정근", ratio: 9.4},
				{party: "undecided", name : "-", ratio: 5.9},
			]
		},
		{
			"requester": "문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 42.1},
				{party: "unitedfuture", name : "서병수", ratio: 33.5},
				{party: "minsaengdang", name : "정해정", ratio: 0.4},
				{party: "noparty", name : "정근", ratio: 6.2},
				{party: "undecided", name : "-", ratio: 15.1},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 40.5},
				{party: "unitedfuture", name : "서병수", ratio: 38.8},
				{party: "minsaengdang", name : "정해정", ratio: 1.0},
				{party: "etcparty", name : "김정희", ratio: 0.4},
				{party: "noparty", name : "정근", ratio: 8.0},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
		{
			"requester": "뉴시스",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영춘", ratio: 46.1},
				{party: "unitedfuture", name : "서병수", ratio: 36.3},
				{party: "minsaengdang", name : "정해정", ratio: 0.9},
				{party: "etcparty", name : "김정희", ratio: 3.4},
				{party: "noparty", name : "정근", ratio: 7.9},
				{party: "undecided", name : "-", ratio: 5.5},
			]
		},
	],
	// 부산 부산진을
	"2260502" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "류영진", ratio: 32.7},
				{party: "unitedfuture", name : "이헌승", ratio: 47.4},
				{party: "undecided", name : "-", ratio: 14.0},
			]
		},
	],
	// 부산 동래
	"2260601" : [
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박성현", ratio: 34.4},
				{party: "unitedfuture", name : "김희곤", ratio: 43.4},
				{party: "justice21", name : "박재완", ratio: 2.7},
				{party: "undecided", name : "-", ratio: 16.0},
			]
		},
	],
	// 부산 남구갑
	"2260701" : [
	],
	// 부산 남구을
	"2260702" : [
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 40.5},
				{party: "unitedfuture", name : "이언주", ratio: 42.6},
				{party: "undecided", name : "-", ratio: 11.6},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 45.4},
				{party: "unitedfuture", name : "이언주", ratio: 44.0},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 51.4},
				{party: "unitedfuture", name : "이언주", ratio: 39.2},
				{party: "etcparty", name : "조호근", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 500,
			desc: "SBS가 여론조사기관 입소스에 의뢰해 지난 28일부터 30일까지 각 지역구의 18세 이상 남녀 유권자 500명씩을 대상으로 실시했고, 조사방식은 유무선 전화면접조사, 응답률은 대구수성을 20.3%, 부산 남을 15.5%, 표본오차는 95% 신뢰수준에 ±4.4%P ",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=055&aid=0000804737",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 51.2},
				{party: "unitedfuture", name : "이언주", ratio: 37.2},
				{party: "etcparty", name : "조호근", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 10.1},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 44.4},
				{party: "unitedfuture", name : "이언주", ratio: 47.8},
				{party: "etcparty", name : "조호근", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 6.1},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 45.5},
				{party: "unitedfuture", name : "이언주", ratio: 45.5},
				// {party: "etcparty", name : "조호근", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 6.4},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박재호", ratio: 46.9},
				{party: "unitedfuture", name : "이언주", ratio: 43.1},
				{party: "etcparty", name : "조호근", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 9.8},
			]
		},
	],
	// 부산 북강서갑
	"2260801" : [
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전재수", ratio: 47.1},
				{party: "unitedfuture", name : "박민식", ratio: 37.2},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전재수", ratio: 48.3},
				{party: "unitedfuture", name : "박민식", ratio: 41.3},
				{party: "undecided", name : "-", ratio: 7.6},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전재수", ratio: 48.5},
				{party: "unitedfuture", name : "박민식", ratio: 43.7},
				{party: "etcparty", name : "이성근", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 5.3},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전재수", ratio: 46.5},
				{party: "unitedfuture", name : "박민식", ratio: 45.6},
				{party: "undecided", name : "-", ratio: 5.5},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전재수", ratio: 58.1},
				{party: "unitedfuture", name : "박민식", ratio: 31.8},
				{party: "etcparty", name : "이성근", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
	],
	// 부산 북강서을
	"2261301" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "최지은", ratio: 34.8},
				{party: "unitedfuture", name : "김도읍", ratio: 44.8},
				{party: "justice21", name : "이의용", ratio: 2.7},
				{party: "minjung", name : "이대진", ratio: 2.8},
				{party: "noparty", name : "강인길", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "4월 6일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "최지은", ratio: 45.8},
				{party: "unitedfuture", name : "김도읍", ratio: 42.4},
				{party: "justice21", name : "이의용", ratio: 0.7},
				// {party: "etcparty", name : "이제현", ratio: 2.8},
				{party: "noparty", name : "강인길", ratio: 1.2},
				{party: "noparty", name : "김원성", ratio: 2.4},
				{party: "undecided", name : "-", ratio: 6.6},
			]
		},
	],
	// 부산 해운대갑
	"2260902" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "유영민", ratio: 30.2},
				{party: "unitedfuture", name : "하태경", ratio: 50.0},
				{party: "undecided", name : "-", ratio: 13.3},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "유영민", ratio: 35.8},
				{party: "unitedfuture", name : "하태경", ratio: 53.1},
				{party: "ourrepublican", name : "한근형", ratio: 2.7},
				{party: "etcparty", name : "이수명", ratio: 0.7},
				{party: "noparty", name : "박주언", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 7.1},
			]
		},
	],
	// 부산 해운대을
	"2260903" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤준호", ratio: 39.3},
				{party: "unitedfuture", name : "김미애", ratio: 41.8},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤준호", ratio: 45.2},
				{party: "unitedfuture", name : "김미애", ratio: 41.7},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
	],
	// 부산 사하갑
	"2261101" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "최인호", ratio: 42.4},
				{party: "unitedfuture", name : "김척수", ratio: 43.8},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 5일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "최인호", ratio: 47.2},
				{party: "unitedfuture", name : "김척수", ratio: 43.2},
				{party: "proparknew", name : "권영", ratio: 0.9},
				{party: "etcparty", name : "이숙희", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 7.6},
			]
		},
		{
			"requester": "아시아투데이",
			"research": "알앤써치",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "최인호", ratio: 50.9},
				{party: "unitedfuture", name : "김척수", ratio: 38.8},
				{party: "undecided", name : "-", ratio: 7.7},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "최인호", ratio: 49.9},
				{party: "unitedfuture", name : "김척수", ratio: 37.3},
				// {party: "etcparty", name : "이숙희", ratio: 2.8},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
	],
	// 부산 사하을
	"2261102" : [
	],
	// 부산 금정
	"2261201" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박무성", ratio: 33.4},
				{party: "unitedfuture", name : "백종헌", ratio: 49.7},
				{party: "minsaengdang", name : "노창동", ratio: 2.5},
				{party: "justice21", name : "신수영", ratio: 3.5},
				// {party: "etcparty", name : "이재화", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 8.8},
			]
		},
	],
	// 부산 연제
	"2261401" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김해영", ratio: 36.6},
				{party: "unitedfuture", name : "이주환", ratio: 45.1},
				{party: "minsaengdang", name : "박재홍", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김해영", ratio: 38.9},
				{party: "unitedfuture", name : "이주환", ratio: 45.2},
				{party: "minsaengdang", name : "박재홍", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 8.4},
			]
		},
		{
			"requester": "부산 MBC",
			"research": "한길리서치센타",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김해영", ratio: 42.0},
				{party: "unitedfuture", name : "이주환", ratio: 50.3},
				{party: "minsaengdang", name : "박재홍", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 6.9},
			]
		},
	],
	// 부산 수영
	"2261501" : [
	],
	// 부산 사상
	"2261601" : [
	],
	// 부산 기장
	"2261002" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "최택용", ratio: 33.8},
				{party: "unitedfuture", name : "정동만", ratio: 45.1},
				{party: "noparty", name : "김한선", ratio: 4.4},
				{party: "undecided", name : "-", ratio: 13.7},
			]
		},
	],
	// 대구 중구남구
	"2270101" : [
	],
	// 대구 동구갑
	"2270201" : [
	],
	// 대구 동구을
	"2270202" : [
	],
	// 대구 서구
	"2270301" : [
	],
	// 대구 북구갑
	"2270501" : [
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이헌태", ratio: 23.0},
				{party: "unitedfuture", name : "양금희", ratio: 34.3},
				{party: "justice21", name : "조명래", ratio: 3.1},
				{party: "ourrepublican", name : "김정준", ratio: 1.7},
				{party: "noparty", name : "정태옥", ratio: 26.8},
				{party: "undecided", name : "-", ratio: 9.4},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이헌태", ratio: 23.9},
				{party: "unitedfuture", name : "양금희", ratio: 42.4},
				{party: "justice21", name : "조명래", ratio: 3.1},
				{party: "ourrepublican", name : "김정준", ratio: 1.4},
				{party: "noparty", name : "정태옥", ratio: 24.5},
				{party: "undecided", name : "-", ratio: 3.6},
			]
		},
	],
	// 대구 북구을
	"2270502" : [
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "홍의락", ratio: 28.4},
				{party: "unitedfuture", name : "김승수", ratio: 40.6},
				{party: "justice21", name : "이영재", ratio: 2.9},
				{party: "undecided", name : "-", ratio: 10.9},
			]
		},
	],
	// 대구 수성갑
	"2270601" : [
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 12일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 32.1},
				{party: "unitedfuture", name : "주호영", ratio: 37.3},
				{party: "undecided", name : "-", ratio: 21.4},
			]
		},
		{
			"requester": "MBN, 매일경제신문사",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 29.2},
				{party: "unitedfuture", name : "주호영", ratio: 52.5},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},

		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 506,
			desc: "중앙일보가 입소스에 의뢰해 경기 성남 분당갑, 안양 동안을, 대구 수성갑, 충남 공주·부여·청양, 전남 목포에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(79.2~80.1% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 안양 동안을과 공주·부여·청양은 24~25일 501~502명, 성남 분당갑, 대구 수성갑·목포는 26~27일 501~506명을 조사했고 유·무선 평균 응답률은 지역별로 10.2~ 20.4%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331080319170",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 37.4},
				{party: "unitedfuture", name : "주호영", ratio: 44.8},
				{party: "proparknew", name : "곽성문", ratio: 1.6},
				{party: "noparty", name : "이진훈", ratio: 5.9},
				{party: "undecided", name : "-", ratio: 9.4},
			]
		},
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 39.2},
				{party: "unitedfuture", name : "주호영", ratio: 49.4},
				{party: "proparknew", name : "곽성문", ratio: 1.6},
				{party: "noparty", name : "이진훈", ratio: 5.7},
				{party: "undecided", name : "-", ratio: 3.2},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 41.3},
				{party: "unitedfuture", name : "주호영", ratio: 38.3},
				{party: "proparknew", name : "곽성문", ratio: 0.7},
				{party: "noparty", name : "이진훈", ratio: 7.6},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 37.1},
				{party: "unitedfuture", name : "주호영", ratio: 44.3},
				{party: "noparty", name : "이진훈", ratio: 7.5},
				{party: "undecided", name : "-", ratio: 10.8},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 502,
			desc: "대구 수성갑 선거구 거주 만 18세 이상 유권자 502명, 표본오차 : 95% 신뢰 수준, ±4.4%p",
			link: "https://imnews.imbc.com/replay/2020/nwdesk/article/5688901_32524.html",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 40.1},
				{party: "unitedfuture", name : "주호영", ratio: 44.0},
				{party: "undecided", name : "-", ratio: 9.8},
			]
		},
		{
			"requester": "대구CBS와 영남일보,KBS대구",
			"research": "에이스리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "대구CBS와 영남일보,KBS대구가 공동으로 여론조사 전문기관 에이스리서치에 의뢰해 진행됐다. 2020년 3월 28일과 29일 이틀간 대구 수성(갑) 선거구에 거주하는 만 18세 이상 성인 남녀를 대상으로 자동응답조사(ARS 100%, 무선/휴대전화 가상번호 82.5%, 유선/무작위생성 표집틀을 통한 임의 전화걸기17.5%)를 실시하였다. 2020년 2월말 행정안전부 주민등록 인구 기준 성·연령·권역별 가중치 부여(셀가중)한 결과이며,표본 수는 508명(전체 23,767명의 통화시도 중 통화성공 9,026명, 응답완료 508명, 응답률 5.6%)이며 오차범위는 95% 신뢰수준에 ±4.3%p이다.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=079&aid=0003343381",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 34.8},
				{party: "unitedfuture", name : "주호영", ratio: 53.4},
				{party: "noparty", name : "이진훈", ratio: 8.2},
				{party: "undecided", name : "-", ratio: 3.0},
			]
		},
		{
			"requester": "서울신문",
			"research": "리서치앤리서치",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%84%9C%EC%9A%B8%ED%8A%B9%EB%B3%84%EC%8B%9C#rfn-61",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 39.9},
				{party: "unitedfuture", name : "주호영", ratio: 47.1},
				{party: "proparknew", name : "곽성문", ratio: 0.2},
				{party: "etcparty", name : "박청정", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 12.3},
			]
		},
		{
			"requester": "국민일보, CBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 42.7},
				{party: "unitedfuture", name : "주호영", ratio: 47.5},
				{party: "proparknew", name : "곽성문", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 6.6},
			]
		},
		{
			"requester": "서울경제",
			"research": "엠브레인퍼블릭",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 37.5},
				{party: "unitedfuture", name : "주호영", ratio: 43.0},
				{party: "undecided", name : "-", ratio: 16.3},
			]
		},
		{
			"requester": " 문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 38.3},
				{party: "unitedfuture", name : "주호영", ratio: 43.9},
				{party: "proparknew", name : "곽성문", ratio: 0.6},
				// {party: "etcparty", name : "박청정", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 15.7},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 38.8},
				{party: "unitedfuture", name : "주호영", ratio: 54.6},
				{party: "proparknew", name : "곽성문", ratio: 0.6},
				{party: "etcparty", name : "박청정", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 5.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김부겸", ratio: 43.6},
				{party: "unitedfuture", name : "주호영", ratio: 48.9},
				{party: "proparknew", name : "곽성문", ratio: 0},
				{party: "etcparty", name : "박청정", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 7.1},
			]
		},
	],
	// 대구 수성을
	"2270602" : [
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 20.1},
				{party: "unitedfuture", name : "이인선", ratio: 32.9},
				{party: "noparty", name : "홍준표", ratio: 35.5},
				{party: "undecided", name : "-", ratio: 5.9},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스 ",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 23.6},
				{party: "unitedfuture", name : "이인선", ratio: 34.6},
				{party: "etcparty", name : "신익수", ratio: 1.9},
				{party: "noparty", name : "홍준표", ratio: 29.1},
				{party: "undecided", name : "-", ratio: 10.8},
			]
		},
		{
			"requester": "대구CBS, 영남일보, KBS대구",
			"research": "에이스리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 508,
			desc: "대구CBS와 영남일보, KBS대구가 공동으로 여론조사 전문기관 에이스리서치에 의뢰해 진행됐다. 2020년 3월 28일과 29일 이틀간 대구 수성(갑) 선거구에 거주하는 만 18세 이상 성인 남녀를 대상으로 자동응답조사(ARS 100%, 무선/휴대전화 가상번호 82.5%, 유선/무작위생성 표집틀을 통한 임의 전화걸기17.5%)를 실시하였다. 2020년 2월말 행정안전부 주민등록 인구 기준 성·연령·권역별 가중치 부여(셀가중)한 결과이며,표본 수는 508명(전체 23,767명의 통화시도 중 통화성공 9,026명, 응답완료 508명, 응답률 5.6%)이며 오차범위는 95% 신뢰수준에 ±4.3%p이다.",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=079&aid=0003343380",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 23.9},
				{party: "unitedfuture", name : "이인선", ratio: 34.4},
				{party: "noparty", name : "홍준표", ratio: 35.5},
				{party: "undecided", name : "-", ratio: 3.9},
			]
		},
		{
			"requester": "경북일보",
			"research": "피플네트웍스 ",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 25.8},
				{party: "unitedfuture", name : "이인선", ratio: 27.8},
				{party: "etcparty", name : "신익수", ratio: 1.1},
				{party: "noparty", name : "홍준표", ratio: 35.2},
				{party: "undecided", name : "-", ratio: 10.1},
			]
		},
		{
			"requester": "미래한국연구소 , V.O.K (Voice of Korea) ",
			"research": "피플네트웍스 ",
			"period": "3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 28.5},
				{party: "unitedfuture", name : "이인선", ratio: 28.8},
				{party: "etcparty", name : "신익수", ratio: 1.9},
				{party: "noparty", name : "홍준표", ratio: 31.7},
				{party: "undecided", name : "-", ratio: 9.1},
			]
		},
		{
			"requester": "미래한국연구소 , V.O.K (Voice of Korea)",
			"research": "피플네트웍스",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 26.4},
				{party: "unitedfuture", name : "이인선", ratio: 28.7},
				{party: "etcparty", name : "신익수", ratio: 2.0},
				{party: "noparty", name : "홍준표", ratio: 37.0},
				{party: "undecided", name : "-", ratio: 5.8},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 24.5},
				{party: "unitedfuture", name : "이인선", ratio: 30.5},
				{party: "etcparty", name : "신익수", ratio: 0.4},
				{party: "noparty", name : "홍준표", ratio: 32.6},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상식", ratio: 22.5},
				{party: "unitedfuture", name : "이인선", ratio: 34.4},
				{party: "etcparty", name : "신익수", ratio: 1.8},
				{party: "noparty", name : "홍준표", ratio: 33.7},
				{party: "undecided", name : "-", ratio: 7.5},
			]
		},
	],
	// 대구 달서갑
	"2270701" : [
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 29일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "권택홍", ratio: 26.5},
				{party: "unitedfuture", name : "홍석준", ratio: 42.3},
				{party: "minsaengdang", name : "김기목", ratio: 0.9},
				{party: "ourrepublican", name : "이성우", ratio: 2.4},
				{party: "noparty", name : "곽대훈", ratio: 16.0},
				{party: "undecided", name : "-", ratio: 10.9},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "권택홍", ratio: 24.6},
				{party: "unitedfuture", name : "홍석준", ratio: 50.2},
				{party: "minsaengdang", name : "김기목", ratio: 1.6},
				{party: "ourrepublican", name : "이성우", ratio: 2.2},
				{party: "noparty", name : "곽대훈", ratio: 17.7},
				{party: "undecided", name : "-", ratio: 3.1},
			]
		},
	],
	// 대구 달서을
	"2270702" : [
	],
	// 대구 달서병
	"2270703" : [
		{
			"requester": "TBC, 매일신문",
			"research": "소셜데이타리서치",
			"period": "3월 29일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김대진", ratio: 22.6},
				{party: "unitedfuture", name : "김용판", ratio: 46.1},
				{party: "ourrepublican", name : "조원진", ratio: 16.5},
				{party: "etcparty", name : "김부기", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 12.2},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김대진", ratio: 28.7},
				{party: "unitedfuture", name : "김용판", ratio: 41.7},
				{party: "ourrepublican", name : "조원진", ratio: 20.5},
				{party: "undecided", name : "-", ratio: 6.2},
			]
		},
	],
	// 대구 달성
	"2270801" : [
	],
	// 인천 중구강화옹진
	"2280101" : [
		{
			"requester": "뉴스웍스",
			"research": "모노커뮤니케이션즈",
			"period": "3월 9일 ~ 3월 10일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "조택상", ratio: 27.8},
				{party: "unitedfuture", name : "배준영", ratio: 31.4},
				{party: "undecided", name : "-", ratio: 32.8},
			]
		},
		{
			"requester": "인천투데이",
			"research": "리서치뷰",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "조택상", ratio: 36.9},
				{party: "unitedfuture", name : "배준영", ratio: 39.7},
				{party: "ourrepublican", name : "조수진", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 15.8},
			]
		},
		{
			"requester": "기호일보, 경기일보",
			"research": "조원씨앤아이",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "조택상", ratio: 44.8},
				{party: "unitedfuture", name : "배준영", ratio: 38.6},
				{party: "ourrepublican", name : "조수진", ratio: 4.7},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
	],
	// 인천 동구미추홀갑
	"2280301" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허종식", ratio: 37.8},
				{party: "unitedfuture", name : "전희경", ratio: 31.2},
				{party: "justice21", name : "문영미", ratio: 7.6},
				{party: "undecided", name : "-", ratio: 19.2},
			]
		},
		{
			"requester": "미디어인천신문",
			"research": "중앙폴리컴(주)",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허종식", ratio: 43.2},
				{party: "unitedfuture", name : "전희경", ratio: 32.3},
				{party: "justice21", name : "문영미", ratio: 6.3},
				{party: "undecided", name : "-", ratio: 16.5},
			]
		},
	],
	// 인천 동구미추홀을
	"2280302" : [
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 32.4},
				{party: "unitedfuture", name : "안상수", ratio: 12.0},
				{party: "noparty", name : "윤상현", ratio: 28.9},
				{party: "undecided", name : "-", ratio: 21.7},
			]
		},
		{
			"requester": "경기일보",
			"research": "조원씨앤아이",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 36.7},
				{party: "unitedfuture", name : "안상수", ratio: 19.9},
				{party: "justice21", name : "정수영", ratio: 4.3},
				{party: "noparty", name : "윤상현", ratio: 25.7},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 16일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 30.5},
				{party: "unitedfuture", name : "안상수", ratio: 21.5},
				{party: "justice21", name : "정수영", ratio: 4.2},
				{party: "noparty", name : "윤상현", ratio: 29.8},
				{party: "undecided", name : "-", ratio: 14.0},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 29.8},
				{party: "unitedfuture", name : "안상수", ratio: 16.9},
				{party: "justice21", name : "정수영", ratio: 4.2},
				{party: "noparty", name : "윤상현", ratio: 37.2},
				{party: "undecided", name : "-", ratio: 10.4},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 37.3},
				{party: "unitedfuture", name : "안상수", ratio: 17.2},
				{party: "justice21", name : "정수영", ratio: 4.6},
				{party: "noparty", name : "윤상현", ratio: 33.0},
				{party: "undecided", name : "-", ratio: 6.0},
			]
		},
		{
			"requester": "인천뉴스",
			"research": "알앤써치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "남영희", ratio: 27.7},
				{party: "unitedfuture", name : "안상수", ratio: 10.6},
				{party: "justice21", name : "정수영", ratio: 4.4},
				{party: "noparty", name : "윤상현", ratio: 34.5},
				{party: "undecided", name : "-", ratio: 20.3},
			]
		},
	],
	// 인천 연수갑
	"2280402" : [
		{
			"requester": "인천투데이",
			"research": "리서치뷰",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박찬대", ratio: 48.0},
				{party: "unitedfuture", name : "정승연", ratio: 35.3},
				{party: "noparty", name : "주진영", ratio: 3.4},
				{party: "undecided", name : "-", ratio: 13.3},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박찬대", ratio: 40.5},
				{party: "unitedfuture", name : "정승연", ratio: 38.1},
				{party: "undecided", name : "-", ratio: 15.4},
			]
		},
	],
	// 인천 연수을
	"2280403" : [
		{
			"requester": "인천뉴스",
			"research": "모노커뮤니케이션즈",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 24.8},
				{party: "unitedfuture", name : "민경욱", ratio: 42.7},
				{party: "justice21", name : "이정미", ratio: 21.5},
				{party: "undecided", name : "-", ratio: 9.0},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 24일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 25.8},
				{party: "unitedfuture", name : "민경욱", ratio: 44.1},
				{party: "justice21", name : "이정미", ratio: 19.0},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "인천투데이",
			"research": "리서치뷰",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 32.4},
				{party: "unitedfuture", name : "민경욱", ratio: 41.7},
				{party: "justice21", name : "이정미", ratio: 19.3},
				{party: "etcparty", name : "주정국", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 6.4},
			]
		},
		{
			"requester": "OBS경인tv",
			"research": "리서치디앤에이",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 31.7},
				{party: "unitedfuture", name : "민경욱", ratio: 40.0},
				{party: "justice21", name : "이정미", ratio: 22.9},
				{party: "undecided", name : "-", ratio: 2.8},
			]
		},
		{
			"requester": "기호일보, 경기일보",
			"research": "조원씨앤아이 ",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 31.4},
				{party: "unitedfuture", name : "민경욱", ratio: 39.5},
				{party: "justice21", name : "이정미", ratio: 19.4},
				{party: "undecided", name : "-", ratio: 7.7},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치 ",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 33.5},
				{party: "unitedfuture", name : "민경욱", ratio: 33.5},
				{party: "justice21", name : "이정미", ratio: 22.6},
				{party: "etcparty", name : "주정국", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치 ",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 30.9},
				{party: "unitedfuture", name : "민경욱", ratio: 38.8},
				{party: "justice21", name : "이정미", ratio: 23.1},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치인터내셔널 ",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 31.7},
				{party: "unitedfuture", name : "민경욱", ratio: 33.7},
				{party: "justice21", name : "이정미", ratio: 24.0},
				// {party: "etcparty", name : "주정국", ratio: 10.5},
				{party: "undecided", name : "-", ratio: 10.5},
			]
		},
		{
			"requester": "뉴시스",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 36.7},
				{party: "unitedfuture", name : "민경욱", ratio: 39.0},
				{party: "justice21", name : "이정미", ratio: 18.5},
				{party: "etcparty", name : "주정국", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 4.8},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정일영", ratio: 36.0},
				{party: "unitedfuture", name : "민경욱", ratio: 39.2},
				{party: "justice21", name : "이정미", ratio: 19.0},
				{party: "etcparty", name : "주정국", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 4.4},
			]
		},
	],
	// 인천 남동갑
	"2280501" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "맹성규", ratio: 38.7},
				{party: "unitedfuture", name : "유정복", ratio: 41.1},
				{party: "undecided", name : "-", ratio: 17.2},
			]
		},
		{
			"requester": "기호일보, 경기일보",
			"research": "조원씨앤아이 ",
			"period": "3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "맹성규", ratio: 46.9},
				{party: "unitedfuture", name : "유정복", ratio: 37.1},
				{party: "undecided", name : "-", ratio: 10.8},
			]
		},
		{
			"requester": "인천투데이",
			"research": "리서치뷰",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "맹성규", ratio: 44.7},
				{party: "unitedfuture", name : "유정복", ratio: 36.3},
				{party: "etcparty", name : "박유민", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 15.8},
			]
		},
		{
			"requester": "OBS경인tv",
			"research": "리서치디앤에이",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "맹성규", ratio: 48.9},
				{party: "unitedfuture", name : "유정복", ratio: 36.2},
				{party: "undecided", name : "-", ratio: 8.5},
			]
		},
	],
	// 인천 남동을
	"2280502" : [
	],
	// 인천 부평갑
	"2280601" : [
	],
	// 인천 부평을
	"2280602" : [
	],
	// 인천 계양갑
	"2280701" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 22일 ~ 3월 23일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "유동수", ratio: 49.7},
				{party: "unitedfuture", name : "이중재", ratio: 27.2},
				{party: "undecided", name : "-", ratio: 15.9},
			]
		},
	],
	// 인천 계양을
	"2280702" : [
	],
	// 인천 서구갑
	"2280802" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김교흥", ratio: 40.0},
				{party: "unitedfuture", name : "이학재", ratio: 37.2},
				{party: "justice21", name : "김중삼", ratio: 7.2},
				{party: "undecided", name : "-", ratio: 12.9},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 15일 ~ 3월 16일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김교흥", ratio: 41.0},
				{party: "unitedfuture", name : "이학재", ratio: 36.4},
				{party: "justice21", name : "김중삼", ratio: 6.6},
				{party: "undecided", name : "-", ratio: 13.1},
			]
		},
		{
			"requester": "OBS경인tv",
			"research": "리서치디앤에이",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김교흥", ratio: 49.2},
				{party: "unitedfuture", name : "이학재", ratio: 35.3},
				{party: "justice21", name : "김중삼", ratio: 4.4},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
		{
			"requester": "기호일보, 경기일보",
			"research": "조원씨앤아이 ",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김교흥", ratio: 49.2},
				{party: "unitedfuture", name : "이학재", ratio: 35.7},
				{party: "justice21", name : "김중삼", ratio: 3.3},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
	],
	// 인천 서구을
	"2280803" : [
	],
	// 광주 동구남구갑
	"2290302" : [
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤영덕", ratio: 64.1},
				{party: "minsaengdang", name : "장병완", ratio: 17.3},
				{party: "etcparty", name : "한기선", ratio: 1.0},
				{party: "etcparty", name : "이안숙", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 16.4},
			]
		},
		{
			"requester": "KBS 광주총국",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤영덕", ratio: 64.8},
				{party: "minsaengdang", name : "장병완", ratio: 23.0},
				{party: "etcparty", name : "한기선", ratio: 0.8},
				{party: "etcparty", name : "이안숙", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 10.7},
			]
		},
	],
	// 광주 동구남구을
	"2290101" : [
		{
			"requester": "뉴스1광주전남본부·광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼",
			"research": "알앤써치",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이병훈", ratio: 55.0},
				{party: "minsaengdang", name : "박주선", ratio: 11.9},
				{party: "justice21", name : "최만원", ratio: 1.6},
				{party: "etcparty", name : "이항숙", ratio: 0.6},
				{party: "noparty", name : "김성환", ratio: 18.8},
				{party: "undecided", name : "-", ratio: 12.1},
			]
		},
		{
			"requester": "광주KBS",
			"research": "한국리서치",
			"period": "3월 31일 ~ 4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이병훈", ratio: 56.7},
				{party: "minsaengdang", name : "박주선", ratio: 7.7},
				{party: "justice21", name : "최만원", ratio: 2.5},
				{party: "noparty", name : "김성환", ratio: 17.8},
				{party: "undecided", name : "-", ratio: 12.3},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소 ",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이병훈", ratio: 60.6},
				{party: "minsaengdang", name : "박주선", ratio: 9.7},
				{party: "justice21", name : "최만원", ratio: 1.2},
				{party: "etcparty", name : "이항숙", ratio: 0.4},
				{party: "noparty", name : "김성환", ratio: 12.0},
				{party: "undecided", name : "-", ratio: 16.0},
			]
		},
	],
	// 광주 서구갑
	"2290201" : [
	],
	// 광주 서구을
	"2290202" : [
		{
			"requester": "광주KBS",
			"research": "한국리서치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "양향자", ratio: 62.9},
				{party: "minsaengdang", name : "천정배", ratio: 18.5},
				{party: "justice21", name : "유종천", ratio: 4.0},
				{party: "etcparty", name : "황윤", ratio: 0.9},
				{party: "noparty", name : "정광선", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 11.2},
			]
		},
		{
			"requester": "뉴스1광주전남본부·광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼",
			"research": "알앤써치",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "양향자", ratio: 52.9},
				{party: "minsaengdang", name : "천정배", ratio: 21.4},
				{party: "justice21", name : "유종천", ratio: 3.5},
				{party: "undecided", name : "-", ratio: 16.5},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "양향자", ratio: 63.2},
				{party: "minsaengdang", name : "천정배", ratio: 20.4},
				{party: "justice21", name : "유종천", ratio: 3.7},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
	],
	// 광주 북구갑
	"2290401" : [
		{
			"requester": "뉴스1광주전남본부·광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼",
			"research": "알앤써치",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 517,
			desc: "응답률은 8.9%이며 표본 오차는 95% 신뢰 수준에 ± 4.3%p. 광주CBS와 광주전남 언론포럼, 광주매일신문, 남도일보, 전남매일, 뉴스1 광주전남 취재본부가 여론조사 전문기관인 알앤써치에 의뢰해 광주 북구갑에 거주하는 만 18세 이상 성인 남녀 517명(가중 500명)을 대상으로 무선전화 자동응답 방식으로 3월 30일과 31일 이틀간 실시",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=079&aid=0003343928",
			data: [
				{party: "theminjoo", name : "조오섭", ratio: 46.7},
				{party: "minsaengdang", name : "범기철", ratio: 3.2},
				{party: "justice21", name : "이승남", ratio: 1.2},
				{party: "noparty", name : "김경진", ratio: 33.6},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
		{
			"requester": "광주KBS",
			"research": "한국리서치",
			"period": "3월 31일 ~ 4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "조오섭", ratio: 42.8},
				{party: "minsaengdang", name : "범기철", ratio: 1.4},
				{party: "justice21", name : "이승남", ratio: 2.1},
				{party: "etcparty", name : "박현두", ratio: 0.4},
				{party: "noparty", name : "김경진", ratio: 38.6},
				{party: "undecided", name : "-", ratio: 14.7},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소 ",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "조오섭", ratio: 45.7},
				{party: "minsaengdang", name : "범기철", ratio: 1.5},
				{party: "justice21", name : "이승남", ratio: 2.5},
				{party: "etcparty", name : "박현두", ratio: 0.7},
				{party: "noparty", name : "김경진", ratio: 37.1},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
	],
	// 광주 북구을
	"2290402" : [
		{
			"requester": "전남도민일보",
			"research": "코리아정보리서치",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이형석", ratio: 48.3},
				{party: "minsaengdang", name : "최경환", ratio: 20.0},
				{party: "justice21", name : "황순영", ratio: 3.9},
				{party: "minjung", name : "윤민호", ratio: 6.5},
				{party: "etcparty", name : "노남수", ratio: 6.9},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "뉴스1광주전남본부·광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼",
			"research": "알앤써치",
			"period": "3월 30일",
			"respondent": 547,
			desc: "응답율은 10.1%, 표본오차는 95% 신뢰수준에 ±4.2%p. 뉴스1광주전남본부와 광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼이 여론조사 전문기관인 알앤써치에 의뢰해 지난 30~31일 광주 북구을 선거구 여론조사를 실시",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=421&aid=0004558286",
			data: [
				{party: "theminjoo", name : "이형석", ratio: 59.1},
				{party: "minsaengdang", name : "최경환", ratio: 12.4},
				{party: "justice21", name : "황순영", ratio: 3.0},
				{party: "minjung", name : "윤민호", ratio: 4.1},
				{party: "undecided", name : "-", ratio: 17.2},
			]
		}
	],
	// 광주 광산갑
	"2290501" : [
		{
			"requester": "뉴스1광주전남본부·광주매일신문·남도일보·전남매일·광주CBS·광주전남언론포럼",
			"research": "알앤써치",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이용빈", ratio: 55.4},
				{party: "minsaengdang", name : "김동철", ratio: 11.8},
				{party: "justice21", name : "나경채", ratio: 5.5},
				{party: "minjung", name : "정희성", ratio: 3.9},
				{party: "undecided", name : "-", ratio: 17.5},
			]
		}
	],
	// 광주 광산을
	"2290502" : [
	],
	// 대전 동구
	"2300101" : [
	],
	// 대전 중구
	"2300201" : [
		{
			"requester": "금강일보",
			"research": "리얼미터",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 510,
			desc: "대전인터넷신문기자협회 소속사(충청뉴스·굿모닝충청·디트뉴스24·대전뉴스)와 금강일보가 리얼미터에 의뢰해 27∼28일 이틀간 대전 중구·서구을에 거주하는 만 18세 이상 남녀 유권자를 대상으로 중구는 510명, 서구을은 505명을 유·무선 혼용(무선 가상번호 80%, 유선 RDD 20%) ARS방식을 사용해 조사했다. 유·무선 평균 응답률은 중구 10.8%, 서구을 10.2%다. 2020년 2월 말 행정안전부 주민등록 인구통계 기준으로 가중치를 적용해 통계를 보정했고 표본오차는 95% 신뢰 수준에서 중구 ±4.3%p, 서구을 ±4.4%이다.",
			link: "http://www.ccnnews.co.kr/news/articleView.html?idxno=176098",
			data: [
				{party: "theminjoo", name : "황운하", ratio: 40.9},
				{party: "unitedfuture", name : "이은권", ratio: 39.6},
				{party: "undecided", name : "-", ratio: 13.1},
			]
		},
		{
			"requester": "대전MBC",
			"research": "코리아리서치인터내셔널",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황운하", ratio: 41.4},
				{party: "unitedfuture", name : "이은권", ratio: 37.1},
				{party: "etcparty", name : "홍세영", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 20.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황운하", ratio: 46.8},
				{party: "unitedfuture", name : "이은권", ratio: 34.7},
				{party: "etcparty", name : "홍세영", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 16.6},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 2일 ~ 4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황운하", ratio: 45.6},
				{party: "unitedfuture", name : "이은권", ratio: 40.1},
				{party: "etcparty", name : "홍세영", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
	],
	// 대전 서구갑
	"2300301" : [
	],
	// 대전 서구을
	"2300302" : [
		{
			"requester": "금강일보",
			"research": "리얼미터",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 505,
			desc: "대전인터넷신문기자협회 소속사(충청뉴스·굿모닝충청·디트뉴스24·대전뉴스)와 금강일보가 리얼미터에 의뢰해 27∼28일 이틀간 대전 중구·서구을에 거주하는 만 18세 이상 남녀 유권자를 대상으로 중구는 510명, 서구을은 505명을 유·무선 혼용(무선 가상번호 80%, 유선 RDD 20%) ARS방식을 사용해 조사했다. 유·무선 평균 응답률은 중구 10.8%, 서구을 10.2%다. 2020년 2월 말 행정안전부 주민등록 인구통계 기준으로 가중치를 적용해 통계를 보정했고 표본오차는 95% 신뢰 수준에서 중구 ±4.3%p, 서구을 ±4.4%이다.",
			link: "http://www.ccnnews.co.kr/news/articleView.html?idxno=176098",
			data: [
				{party: "theminjoo", name : "박범계", ratio: 45.9},
				{party: "unitedfuture", name : "양홍규", ratio: 38.4},
				{party: "ourrepublican", name : "이동규", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 16.3},
			]
		},
		{
			"requester": "대전MBC",
			"research": "코리아리서치인터내셔널",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박범계", ratio: 54.7},
				{party: "unitedfuture", name : "양홍규", ratio: 29.1},
				{party: "ourrepublican", name : "이동규", ratio: 0.8},
				{party: "etcparty", name : "김정열", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 2일 ~ 4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박범계", ratio: 52.1},
				{party: "unitedfuture", name : "양홍규", ratio: 36.8},
				{party: "ourrepublican", name : "이동규", ratio: 1.3},
				{party: "etcparty", name : "김정열", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 8.2},
			]
		},
	],
	// 대전 유성갑
	"2300402" : [
	],
	// 대전 유성을
	"2300403" : [
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 2일 ~ 4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상민", ratio: 48.7},
				{party: "unitedfuture", name : "김소연", ratio: 35.6},
				{party: "justice21", name : "김윤기", ratio: 3.8},
				{party: "etcparty", name : "이범용", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 10.0},
			]
		},
	],
	// 대전 대덕
	"2300501" : [
	],
	// 울산 중구
	"2310101" : [
	],
	// 울산 남구갑
	"2310201" : [
	],
	// 울산 남구을
	"2310202" : [
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "박성진", ratio: 29.3},
				{party: "unitedfuture", name : "김기현", ratio: 55.0},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
	],
	// 울산 동구
	"2310301" : [
	],
	// 울산 북구
	"2310401" : [
	],
	// 울산 울주
	"2310501" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김영문", ratio: 37.8},
				{party: "unitedfuture", name : "서범수", ratio: 51.2},
				// {party: "etcparty", name : "고진복", ratio: 0.5},
				// {party: "noparty", name : "전상환", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 8.3},
			]
		},
	],
	// 세종 세종시갑
	"2510101" : [
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "홍성국", ratio: 41.4},
				{party: "unitedfuture", name : "김중로", ratio: 35.8},
				{party: "justice21", name : "이혁재", ratio: 4.7},
				{party: "etcparty", name : "김영호", ratio: 1.6},
				{party: "noparty", name : "박상래", ratio: 0.3},
				{party: "noparty", name : "윤형권", ratio: 4.1},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
	],
	// 세종 세종시을
	"2510102" : [
		{
			"requester": "MBN, 매일경제신문사 의뢰",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강준현", ratio: 50.3},
				{party: "unitedfuture", name : "김병준", ratio: 32.2},
				{party: "minsaengdang", name : "정원희", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 13.5},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강준현", ratio: 46.5},
				{party: "unitedfuture", name : "김병준", ratio: 36.2},
				{party: "minsaengdang", name : "정원희", ratio: 2.1},
				{party: "noparty", name : "정태준", ratio: 3.4},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강준현", ratio: 50.2},
				{party: "unitedfuture", name : "김병준", ratio: 29.5},
				{party: "minsaengdang", name : "정원희", ratio: 0.8},
				{party: "noparty", name : "정태준", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 18.6},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강준현", ratio: 54.9},
				{party: "unitedfuture", name : "김병준", ratio: 26.3},
				{party: "minsaengdang", name : "정원희", ratio: 1.8},
				{party: "noparty", name : "정태준", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 15.4},
			]
		},
		{
			"requester": "세종매일",
			"research": "이너텍시스템즈",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강준현", ratio: 47.3},
				{party: "unitedfuture", name : "김병준", ratio: 35.5},
				{party: "minsaengdang", name : "정원희", ratio: 4.3},
				{party: "noparty", name : "정태준", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
	],
	// 경기 수원갑
	"2410101" : [
	],
	// 경기 수원을
	"2410201" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 9일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "백혜련", ratio: 41.2},
				{party: "unitedfuture", name : "정미경", ratio: 38.4},
				{party: "undecided", name : "-", ratio: 16.9},
			]
		},
		{
			"requester": "중부일보",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "백혜련", ratio: 47.9},
				{party: "unitedfuture", name : "정미경", ratio: 34.9},
				{party: "undecided", name : "-", ratio: 13.9},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "백혜련", ratio: 58.7},
				{party: "unitedfuture", name : "정미경", ratio: 28.1},
				{party: "undecided", name : "-", ratio: 9.8},
			]
		},
	],
	// 경기 수원병
	"2410301" : [
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김영진", ratio: 49.1},
				{party: "unitedfuture", name : "김용남", ratio: 32.2},
				{party: "justice21", name : "박예휘", ratio: 3.1},
				{party: "ourrepublican", name : "진재범", ratio: 1.4},
				{party: "minjung", name : "임미숙", ratio: 2.7},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김영진", ratio: 49.6},
				{party: "unitedfuture", name : "김용남", ratio: 36.2},
				{party: "justice21", name : "박예휘", ratio: 2.1},
				{party: "ourrepublican", name : "진재범", ratio: 0.9},
				{party: "minjung", name : "임미숙", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
	],
	// 경기 수원정
	"2410401" : [
	],
	// 경기 수원무
	"2410202" : [
	],
	// 경기 성남수정
	"2410501" : [
	],
	// 경기 성남중원
	"2410601" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 13일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "윤영찬", ratio: 41.8},
				{party: "unitedfuture", name : "신상진", ratio: 32.7},
				{party: "minjung", name : "김미희", ratio: 3.8},
				{party: "undecided", name : "-", ratio: 17.2},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "3월 23일 ~ 3월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "윤영찬", ratio: 42.0},
				{party: "unitedfuture", name : "신상진", ratio: 30.2},
				{party: "minjung", name : "김미희", ratio: 5.1},
				{party: "undecided", name : "-", ratio: 21.6},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "윤영찬", ratio: 50.7},
				{party: "unitedfuture", name : "신상진", ratio: 33.1},
				{party: "minjung", name : "김미희", ratio: 7.0},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "윤영찬", ratio: 52.2},
				{party: "unitedfuture", name : "신상진", ratio: 27.7},
				{party: "minjung", name : "김미희", ratio: 4.7},
				{party: "etcparty", name : "오성은", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 15.2},
			]
		},
	],
	// 경기 성남분당갑
	"2410701" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김병관", ratio: 43.0},
				{party: "unitedfuture", name : "김은혜", ratio: 37.4},
				{party: "undecided", name : "-", ratio: 15.1},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 506,
			desc: "중앙일보가 입소스에 의뢰해 경기 성남 분당갑, 안양 동안을, 대구 수성갑, 충남 공주·부여·청양, 전남 목포에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(79.2~80.1% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 안양 동안을과 공주·부여·청양은 24~25일 501~502명, 성남 분당갑, 대구 수성갑·목포는 26~27일 501~506명을 조사했고 유·무선 평균 응답률은 지역별로 10.2~ 20.4%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331080319170",
			data: [
				{party: "theminjoo", name : "김병관", ratio: 45.6},
				{party: "unitedfuture", name : "김은혜", ratio: 35.3},
				{party: "undecided", name : "-", ratio: 16.4},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김병관", ratio: 46.9},
				{party: "unitedfuture", name : "김은혜", ratio: 44.1},
				{party: "undecided", name : "-", ratio: 8.2},
			]
		},
		{
			"requester": "문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김병관", ratio: 38.9},
				{party: "unitedfuture", name : "김은혜", ratio: 39.3},
				{party: "undecided", name : "-", ratio: 20.1},
			]
		},
	],
	// 경기 성남분당을
	"2410702" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김병욱", ratio: 36.3},
				{party: "unitedfuture", name : "김민수", ratio: 39.9},
				{party: "justice21", name : "양호영", ratio: 3.5},
				{party: "minjung", name : "김양현", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 16.8},
			]
		},
	],
	// 경기 의정부갑
	"2410801" : [
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 42.6},
				{party: "unitedfuture", name : "강세창", ratio: 31.7},
				{party: "noparty", name : "문석균", ratio: 11.5},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 41.8},
				{party: "unitedfuture", name : "강세창", ratio: 28.4},
				{party: "noparty", name : "문석균", ratio: 9.0},
				{party: "undecided", name : "-", ratio: 19.8},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 45.1},
				{party: "unitedfuture", name : "강세창", ratio: 28.0},
				{party: "etcparty", name : "이종동", ratio: 0.8},
				{party: "noparty", name : "문석균", ratio: 7.0},
				{party: "undecided", name : "-", ratio: 19.1},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 45.3},
				{party: "unitedfuture", name : "강세창", ratio: 33.1},
				{party: "etcparty", name : "이종동", ratio: 1.0},
				{party: "noparty", name : "문석균", ratio: 8.2},
				{party: "undecided", name : "-", ratio: 11.3},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 48.8},
				{party: "unitedfuture", name : "강세창", ratio: 28.9},
				// {party: "etcparty", name : "이종동", ratio: 1.0},
				{party: "noparty", name : "문석균", ratio: 10.6},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
		{
			"requester": "뉴스토마토",
			"research": "한국사회여론연구소",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오영환", ratio: 48.8},
				{party: "unitedfuture", name : "강세창", ratio: 29.0},
				// {party: "etcparty", name : "이종동", ratio: 1.0},
				{party: "noparty", name : "문석균", ratio: 9.6},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
	],
	// 경기 의정부을
	"2410802" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 23일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김민철", ratio: 50.6},
				{party: "unitedfuture", name : "이형섭", ratio: 32.1},
				{party: "minjung", name : "김재연", ratio: 3.9},
				{party: "undecided", name : "-", ratio: 6.2},
			]
		},
	],
	// 경기 안양만안
	"2410901" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "강득구", ratio: 43.0},
				{party: "unitedfuture", name : "이필운", ratio: 39.7},
				{party: "justice21", name : "이종태", ratio: 4.3},
				{party: "undecided", name : "-", ratio: 9.3},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "강득구", ratio: 43.7},
				{party: "unitedfuture", name : "이필운", ratio: 38.1},
				{party: "justice21", name : "이종태", ratio: 3.7},
				{party: "noparty", name : "장경순", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
	],
	// 경기 안양동안갑
	"2411001" : [
	],
	// 경기 안양동안을
	"2411002" : [
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 12일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 42.8},
				{party: "unitedfuture", name : "심재철", ratio: 33.4},
				{party: "justice21", name : "추혜선", ratio: 5.5},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
		// {
		// 	"requester": "MBN, 매일경제신문사",
		// 	"research": "알앤써치",
		// 	"period": "3월 24일 ~ 3월 25일",
		// 	"respondent": 500,
		// 	desc: "응답자수 미표기로 인해 500으로 처리",
		// 	link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
		// 	data: [
		// 		{party: "theminjoo", name : "이재정", ratio: 53.3},
		// 		{party: "unitedfuture", name : "심재철", ratio: 31.8},
		// 		{party: "justice21", name : "추혜선", ratio: 2.3},
		// 		{party: "undecided", name : "-", ratio: 9.5},
		// 	]
		// },
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 24일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 44.3},
				{party: "unitedfuture", name : "심재철", ratio: 40.0},
				{party: "justice21", name : "추혜선", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 9.8},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 24일 ~ 3월 25일",
			"respondent": 501,
			desc: "중앙일보가 입소스에 의뢰해 경기 성남 분당갑, 안양 동안을, 대구 수성갑, 충남 공주·부여·청양, 전남 목포에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(79.2~80.1% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 안양 동안을과 공주·부여·청양은 24~25일 501~502명, 성남 분당갑, 대구 수성갑·목포는 26~27일 501~506명을 조사했고 유·무선 평균 응답률은 지역별로 10.2~ 20.4%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331080319170",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 48.3},
				{party: "unitedfuture", name : "심재철", ratio: 35.0},
				{party: "justice21", name : "추혜선", ratio: 6.4},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
		{
			"requester": "MBC",
			"research": "코리아리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 502,
			desc: "표본오차 : 95% 신뢰 수준, ±4.4%p",
			link: "https://imnews.imbc.com/replay/2020/nwdesk/article/5688900_32524.html",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 46.8},
				{party: "unitedfuture", name : "심재철", ratio: 33.6},
				{party: "justice21", name : "추혜선", ratio: 7.1},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 52.9},
				{party: "unitedfuture", name : "심재철", ratio: 33.4},
				{party: "minsaengdang", name : "문태환", ratio: 1.2},
				{party: "justice21", name : "추혜선", ratio: 3.7},
				{party: "undecided", name : "-", ratio: 7.1},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 55.6},
				{party: "unitedfuture", name : "심재철", ratio: 34.1},
				{party: "minsaengdang", name : "문태환", ratio: 0.2},
				{party: "justice21", name : "추혜선", ratio: 3.2},
				{party: "etcparty", name : "이주애", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 6.0},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이재정", ratio: 54.3},
				{party: "unitedfuture", name : "심재철", ratio: 35.4},
				{party: "minsaengdang", name : "문태환", ratio: 1.4},
				{party: "justice21", name : "추혜선", ratio: 3.6},
				{party: "etcparty", name : "이주애", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 2.8},
			]
		},
	],
	// 경기 부천갑
	"2411101" : [
	],
	// 경기 부천을
	"2411102" : [
	],
	// 경기 부천병
	"2411201" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김상희", ratio: 53.2},
				{party: "unitedfuture", name : "차명진", ratio: 26.7},
				{party: "justice21", name : "신현자", ratio: 3.5},
				{party: "undecided", name : "-", ratio: 16.6},
			]
		},
	],
	// 경기 부천정
	"2411301" : [
	],
	// 경기 광명갑
	"2411401" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "임오경", ratio: 38.6},
				{party: "unitedfuture", name : "양주상", ratio: 37.3},
				{party: "minsaengdang", name : "양순필", ratio: 6.1},
				{party: "etcparty", name : "김상연", ratio: 1.5},
				{party: "noparty", name : "김경표", ratio: 4.1},
				{party: "noparty", name : "권태진", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 9.6},
			]
		},
	],
	// 경기 광명을
	"2411402" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "양기대", ratio: 52.7},
				{party: "unitedfuture", name : "김용태", ratio: 26.2},
				{party: "undecided", name : "-", ratio: 14.4},
			]
		},
	],
	// 경기 평택갑
	"2411501" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 17일 ~ 3월 18일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "홍기원", ratio: 41.8},
				{party: "unitedfuture", name : "공재광", ratio: 39.0},
				{party: "undecided", name : "-", ratio: 14.3},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 20일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "홍기원", ratio: 37.3},
				{party: "unitedfuture", name : "공재광", ratio: 40.1},
				{party: "undecided", name : "-", ratio: 15.5},
			]
		},
		{
			"requester": "평택시민신문, 평택신문, 평택자치신문, 평택시사신문",
			"research": "리서치뷰",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "홍기원", ratio: 37.9},
				{party: "unitedfuture", name : "공재광", ratio: 40.7},
				{party: "etcparty", name : "곽해춘", ratio: 1.5},
				{party: "noparty", name : "차화열", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 17.5},
			]
		},
		{
			"requester": "평택시민신문, 평택신문, 평택자치신문, 평택시사신문",
			"research": "리서치뷰",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "홍기원", ratio: 41.3},
				{party: "unitedfuture", name : "공재광", ratio: 42.2},
				{party: "etcparty", name : "곽해춘", ratio: 1.0},
				{party: "noparty", name : "차화열", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 13.7},
			]
		},
	],
	// 경기 평택을
	"2411502" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 13일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김현정", ratio: 36.3},
				{party: "unitedfuture", name : "유의동", ratio: 36.6},
				{party: "minjung", name : "김양현", ratio: 3.3},
				{party: "undecided", name : "-", ratio: 19.1},
			]
		},
		{
			"requester": "평택시민신문, 평택신문, 평택자치신문, 평택시사신문",
			"research": "리서치뷰",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김현정", ratio: 38.6},
				{party: "unitedfuture", name : "유의동", ratio: 45.5},
				{party: "minjung", name : "김양현", ratio: 1.4},
				{party: "etcparty", name : "장재혁", ratio: 1.8},
				{party: "noparty", name : "허승녕", ratio: 1.2},
				{party: "noparty", name : "이인숙", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김현정", ratio: 41.3},
				{party: "unitedfuture", name : "유의동", ratio: 37.4},
				{party: "minjung", name : "김양현", ratio: 3.2},
				// {party: "etcparty", name : "장재혁", ratio: 2.7},
				{party: "noparty", name : "허승녕", ratio: 2.7},
				{party: "noparty", name : "이인숙", ratio: 4.1},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
		{
			"requester": "평택시민신문, 평택신문, 평택자치신문, 평택시사신문",
			"research": "리서치뷰",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김현정", ratio: 43.4},
				{party: "unitedfuture", name : "유의동", ratio: 40.4},
				{party: "minjung", name : "김양현", ratio: 1.5},
				{party: "etcparty", name : "장재혁", ratio: 0.6},
				{party: "noparty", name : "허승녕", ratio: 1.4},
				{party: "noparty", name : "이인숙", ratio: 2.6},
				{party: "undecided", name : "-", ratio: 10.0},
			]
		},
	],
	// 경기 동두천연천
	"2411701" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 9일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "서동욱", ratio: 35.9},
				{party: "unitedfuture", name : "김성원", ratio: 44.6},
				{party: "undecided", name : "-", ratio: 15.0},
			]
		},
	],
	// 경기 안산상록갑
	"2411801" : [
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "전해철", ratio: 58.4},
				{party: "unitedfuture", name : "박주원", ratio: 25.7},
				{party: "ourrepublican", name : "이기학", ratio: 1.9},
				{party: "minjung", name : "홍연아", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 11.0},
			]
		},
	],
	// 경기 안산상록을
	"2411802" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김철민", ratio: 51.8},
				{party: "unitedfuture", name : "홍장표", ratio: 28.0},
				{party: "undecided", name : "-", ratio: 17.9},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 30일 ~ 3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김철민", ratio: 46.9},
				{party: "unitedfuture", name : "홍장표", ratio: 28.3},
				{party: "undecided", name : "-", ratio: 20.9},
			]
		},
	],
	// 경기 안산단원갑
	"2411901" : [
	],
	// 경기 안산단원을
	"2411902" : [
		{
			"requester": "MBN, 매일경제신문사",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김남국", ratio: 40.7},
				{party: "unitedfuture", name : "박순자", ratio: 36.3},
				{party: "ourrepublican", name : "정우혁", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 16.3},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김남국", ratio: 49.0},
				{party: "unitedfuture", name : "박순자", ratio: 35.8},
				{party: "ourrepublican", name : "정우혁", ratio: 1.1},
				{party: "etcparty", name : "이윤배", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 13.5},
			]
		},
	],
	// 경기 고양갑
	"2412001" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "문명순", ratio: 26.5},
				{party: "unitedfuture", name : "이경환", ratio: 33.5},
				{party: "justice21", name : "심상정", ratio: 26.3},
				{party: "undecided", name : "-", ratio: 10.6},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "문명순", ratio: 33.5},
				{party: "unitedfuture", name : "이경환", ratio: 20.7},
				{party: "justice21", name : "심상정", ratio: 34.5},
				{party: "etcparty", name : "고평기", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
		{
			"requester": "TV조선",
			"research": "메트릭스리서치",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "문명순", ratio: 26.2},
				{party: "unitedfuture", name : "이경환", ratio: 27.3},
				{party: "justice21", name : "심상정", ratio: 37.5},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "문명순", ratio: 24.1},
				{party: "unitedfuture", name : "이경환", ratio: 22.7},
				{party: "justice21", name : "심상정", ratio: 40.1},
				// {party: "etcparty", name : "고평기", ratio: 37.5},
				// {party: "undecided", name : "-", ratio: 8.6},
			]
		},
	],
	// 경기 고양을
	"2412002" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 20일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "한준호", ratio: 42.6},
				{party: "unitedfuture", name : "함경우", ratio: 33.1},
				{party: "justice21", name : "박원석", ratio: 4.9},
				{party: "etcparty", name : "송영주", ratio: 2.1},
				{party: "noparty", name : "박종원", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 13.3},
			]
		},
		{
			"requester": "뉴스토마토",
			"research": "한국사회여론연구소",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "한준호", ratio: 48.0},
				{party: "unitedfuture", name : "함경우", ratio: 27.6},
				{party: "justice21", name : "박원석", ratio: 6.2},
				{party: "etcparty", name : "송영주", ratio: 4.4},
				// {party: "noparty", name : "박종원", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 10.9},
			]
		},
	],
	// 경기 고양병
	"2412101" : [
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "홍정민", ratio: 47.4},
				{party: "unitedfuture", name : "김영환", ratio: 37.4},
				{party: "ourrepublican", name : "김근복", ratio: 1.3},
				// {party: "etcparty", name : "정재우", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 10.2},
			]
		},
	],
	// 경기 고양정
	"2412201" : [
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 12일 ~ 3월 13일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84#rfn-57",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 42.2},
				{party: "unitedfuture", name : "김현아", ratio: 31.3},
				{party: "undecided", name : "-", ratio: 20.0},
			]
		},
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 35.7},
				{party: "unitedfuture", name : "김현아", ratio: 29.0},
				{party: "undecided", name : "-", ratio: 25.7},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 16일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 37.4},
				{party: "unitedfuture", name : "김현아", ratio: 38.8},
				{party: "undecided", name : "-", ratio: 17.8},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 40.5},
				{party: "unitedfuture", name : "김현아", ratio: 40.2},
				{party: "undecided", name : "-", ratio: 10.9},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 46.8},
				{party: "unitedfuture", name : "김현아", ratio: 37.9},
				{party: "undecided", name : "-", ratio: 11.8},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 49.0},
				{party: "unitedfuture", name : "김현아", ratio: 31.6},
				{party: "undecided", name : "-", ratio: 0},
			]
		},
		{
			"requester": "CBS, 국민일보",
			"research": "조원씨앤아이",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이용우", ratio: 42.2},
				{party: "unitedfuture", name : "김현아", ratio: 46.4},
				{party: "undecided", name : "-", ratio: 9.1},
			]
		},
	],
	// 경기 의왕과천
	"2412301" : [
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이소영", ratio: 38.3},
				{party: "unitedfuture", name : "신계용", ratio: 31.3},
				{party: "minsaengdang", name : "김성제", ratio: 15.7},
				{party: "justice21", name : "황순식", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 9.4},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이소영", ratio: 39.2},
				{party: "unitedfuture", name : "신계용", ratio: 30.4},
				{party: "minsaengdang", name : "김성제", ratio: 13.0},
				{party: "justice21", name : "황순식", ratio: 2.7},
				{party: "undecided", name : "-", ratio: 14.7},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이소영", ratio: 39.4},
				{party: "unitedfuture", name : "신계용", ratio: 32.5},
				{party: "minsaengdang", name : "김성제", ratio: 14.6},
				{party: "justice21", name : "황순식", ratio: 2.4},
				{party: "undecided", name : "-", ratio: 9.0},
			]
		},
	],
	// 경기 구리
	"2412501" : [
	],
	// 경기 남양주갑
	"2412601" : [
	],
	// 경기 남양주을
	"2412602" : [
	],
	// 경기 남양주병
	"2412603" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김용민", ratio: 41.7},
				{party: "unitedfuture", name : "주광덕", ratio: 41.1},
				{party: "justice21", name : "장형진", ratio: 2.7},
				{party: "undecided", name : "-", ratio: 12.8},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 15일 ~ 3월 16일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김용민", ratio: 41.5},
				{party: "unitedfuture", name : "주광덕", ratio: 41.1},
				{party: "justice21", name : "장형진", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 12.4},
			]
		},
	],
	// 경기 오산
	"2412701" : [
	],
	// 경기 시흥갑
	"2412901" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "문정복", ratio: 47.5},
				{party: "unitedfuture", name : "함진규", ratio: 35.6},
				{party: "justice21", name : "양범진", ratio: 3.6},
				{party: "undecided", name : "-", ratio: 10.2},
			]
		},
	],
	// 경기 시흥을
	"2412902" : [
	],
	// 경기 군포
	"2413002" : [
	],
	// 경기 하남
	"2413101" : [
	],
	// 경기 용인갑
	"2413501" : [
		{
			"requester": "경기일보, 기호일보",
			"research": "조원씨앤아이",
			"period": "4월 5일 ~ 5월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "오세영", ratio: 43.8},
				{party: "unitedfuture", name : "정찬민", ratio: 44.3},
				// {party: "etcparty", name : "정이주", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
	],
	// 경기 용인을
	"2413701" : [
	],
	// 경기 용인병
	"2413602" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "정춘숙", ratio: 37.0},
				{party: "unitedfuture", name : "이상일", ratio: 44.9},
				{party: "undecided", name : "-", ratio: 14.6},
			]
		},
	],
	// 경기 용인정
	"2413702" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이탄희", ratio: 45.1},
				{party: "unitedfuture", name : "김범수", ratio: 39.0},
				{party: "minjung", name : "김배곤", ratio: 3.0},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이탄희", ratio: 43.3},
				{party: "unitedfuture", name : "김범수", ratio: 43.4},
				{party: "minjung", name : "김배곤", ratio: 2.0},
				{party: "proparknew", name : "김근기", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 7.2},
			]
		},
	],
	// 경기 파주갑
	"2413202" : [
	],
	// 경기 파주을
	"2413203" : [
	],
	// 경기 이천
	"2413401" : [
		// {
		// 	"requester": "중부일보",
		// 	"research": "아이소프트뱅크",
		// 	"period": "4월 5일",
		// 	"respondent": 500,
		// 	desc: "응답자수 미표기로 인해 500으로 처리",
		// 	link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
		// 	data: [
		// 		{party: "theminjoo", name : "김용진", ratio: 35.4},
		// 		{party: "unitedfuture", name : "송석준", ratio: 26.8},
		// 		{party: "etcparty", name : "천종만", ratio: 12.7},
		// 		{party: "noparty", name : "홍준의", ratio: 12.7},
		// 		{party: "undecided", name : "-", ratio: 25.1},
		// 	]
		// },
	],
	// 경기 안성
	"2413801" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이규민", ratio: 43.5},
				{party: "unitedfuture", name : "김학용", ratio: 43.8},
				// {party: "etcparty", name : "송민정", ratio: 3.6},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
	],
	// 경기 김포갑
	"2413902" : [
		{
			"requester": "김포지역신문협의회, 김포신문",
			"research": "조원씨앤아이",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "김주영", ratio: 35.4},
				{party: "unitedfuture", name : "박진호", ratio: 26.8},
				{party: "justice21", name : "유영록", ratio: 12.7},
				{party: "undecided", name : "-", ratio: 25.1},
			]
		},
	],
	// 경기 김포을
	"2413903" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "박상혁", ratio: 48.2},
				{party: "unitedfuture", name : "홍철호", ratio: 37.2},
				{party: "minsaengdang", name : "박채순", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 9.4},
			]
		},
		{
			"requester": "김포지역신문협의회, 김포신문",
			"research": "조원씨앤아이",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "박상혁", ratio: 43.2},
				{party: "unitedfuture", name : "홍철호", ratio: 31.6},
				{party: "minsaengdang", name : "박채순", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 22.8},
			]
		},
	],
	// 경기 화성갑
	"2412801" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "송옥주", ratio: 38.8},
				{party: "unitedfuture", name : "최영근", ratio: 35.5},
				{party: "minjung", name : "홍성규", ratio: 4.0},
				{party: "noparty", name : "김용", ratio: 3.8},
				{party: "undecided", name : "-", ratio: 13.9},
			]
		},
	],
	// 경기 화성을
	"2412802" : [
	],
	// 경기 화성병
	"2412803" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "권칠승", ratio: 45.7},
				{party: "unitedfuture", name : "석호현", ratio: 32.1},
				{party: "undecided", name : "-", ratio: 17.5},
			]
		},
	],
	// 경기 광주갑
	"2414002" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "소병훈", ratio: 49.9},
				{party: "unitedfuture", name : "조억동", ratio: 36.5},
				{party: "etcparty", name : "엄태영", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 10.1},
			]
		},
	],
	// 경기 광주을
	"2414003" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "임종성", ratio: 40.0},
				{party: "unitedfuture", name : "김장수", ratio: 34.2},
				{party: "undecided", name : "-", ratio: 19.8},
			]
		},
	],
	// 경기 양주
	"2411602" : [
	],
	// 경기 포천가평
	"2414102" : [
		{
			"requester": "경인일보",
			"research": "알앤써치",
			"period": "3월 22일 ~ 3월 23일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "이철휘", ratio: 34.7},
				{party: "unitedfuture", name : "최춘식", ratio: 39.9},
				{party: "minjung", name : "이명원", ratio: 4.3},
				{party: "undecided", name : "-", ratio: 16.5},
			]
		},
		// {
		// 	"requester": "포천뉴스",
		// 	"research": "비전코리아솔루션즈",
		// 	"period": "3월 27일 ~ 3월 28일",
		// 	"respondent": 500,
		// 	desc: "응답자수 미표기로 인해 500으로 처리",
		// 	link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
		// 	data: [
		// 		{party: "theminjoo", name : "이철휘", ratio: 40.1},
		// 		{party: "unitedfuture", name : "최춘식", ratio: 39.0},
		// 		{party: "undecided", name : "-", ratio: 16.4},
		// 	]
		// },
	],
	// 경기 여주양평
	"2413301" : [
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "최재관", ratio: 37.9},
				{party: "unitedfuture", name : "김선교", ratio: 46.7},
				{party: "justice21", name : "유상진", ratio: 3.6},
				{party: "undecided", name : "-", ratio: 9.0},
			]
		},
		{
			"requester": "중부일보",
			"research": "아이소프트뱅크",
			"period": "3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "최재관", ratio: 41.4},
				{party: "unitedfuture", name : "김선교", ratio: 42.4},
				{party: "justice21", name : "유상진", ratio: 3.5},
				{party: "ourrepublican", name : "변성근", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
		{
			"requester": "세종신문사",
			"research": "세종리서치",
			"period": "4월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EB%8F%84",
			data: [
				{party: "theminjoo", name : "최재관", ratio: 43.6},
				{party: "unitedfuture", name : "김선교", ratio: 43.6},
				{party: "justice21", name : "유상진", ratio: 4.0},
				{party: "ourrepublican", name : "변성근", ratio: 0.6},
				{party: "etcparty", name : "김미화", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 7.9},
			]
		},
	],
	// 강원 춘천철원화천양구갑
	"2420101" : [
		{
			"requester": "강원도민일보",
			"research": "디오피니언",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 501,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "허영", ratio: 44.5},
				{party: "unitedfuture", name : "김진태", ratio: 41.8},
				{party: "justice21", name : "엄재철", ratio: 4.6},
				{party: "etcparty", name : "한준모", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 6.9},
			]
		},
		{
			"requester": "강원일보, KBS춘천, 춘천MBC",
			"research": "코리아리서치인터내셔널",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 503,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "허영", ratio: 44.2},
				{party: "unitedfuture", name : "김진태", ratio: 37.3},
				{party: "justice21", name : "엄재철", ratio: 6.0},
				{party: "etcparty", name : "한준모", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "G1",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허영", ratio: 48.8},
				{party: "unitedfuture", name : "김진태", ratio: 35.7},
				{party: "justice21", name : "엄재철", ratio: 6.0},
				{party: "etcparty", name : "한준모", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허영", ratio: 45.0},
				{party: "unitedfuture", name : "김진태", ratio: 38.1},
				{party: "justice21", name : "엄재철", ratio: 5.0},
				{party: "etcparty", name : "한준모", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "CBS",
			"research": "조원씨앤아이",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허영", ratio: 44.6},
				{party: "unitedfuture", name : "김진태", ratio: 45.8},
				{party: "justice21", name : "엄재철", ratio: 4.6},
				// {party: "etcparty", name : "한준모", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 4.1},
			]
		},
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허영", ratio: 47.5},
				{party: "unitedfuture", name : "김진태", ratio: 42.5},
				{party: "justice21", name : "엄재철", ratio: 2.4},
				{party: "etcparty", name : "한준모", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 7.2},
			]
		},
	],
	// 강원 춘천철원화천양구을
	"2420102" : [
		{
			"requester": "G1",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정만호", ratio: 41.9},
				{party: "unitedfuture", name : "한기호", ratio: 39.3},
				{party: "etcparty", name : "유우림", ratio: 1.3},
				{party: "undecided", name : "-", ratio: 17.6},
			]
		},
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정만호", ratio: 43.9},
				{party: "unitedfuture", name : "한기호", ratio: 38.3},
				{party: "etcparty", name : "유우림", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 16.3},
			]
		},
	],
	// 강원 원주갑
	"2420202" : [
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 43.2},
				{party: "unitedfuture", name : "박정하", ratio: 25.8},
				{party: "undecided", name : "-", ratio: 19.1},
			]
		},
		{
			"requester": "강원도민일보",
			"research": "디오피니언",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 501,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 46.7},
				{party: "unitedfuture", name : "박정하", ratio: 32.7},
				{party: "ourrepublican", name : "이강범", ratio: 1.7},
				{party: "etcparty", name : "정상균", ratio: 1.4},
				{party: "noparty", name : "권성중", ratio: 9.4},
				{party: "undecided", name : "-", ratio: 8.1},
			]
		},
		{
			"requester": "강원일보, KBS춘천, 춘천MBC",
			"research": "코리아리서치",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 501,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 46.8},
				{party: "unitedfuture", name : "박정하", ratio: 24.8},
				{party: "ourrepublican", name : "이강범", ratio: 1.2},
				{party: "etcparty", name : "정상균", ratio: 1.0},
				{party: "noparty", name : "권성중", ratio: 8.4},
				{party: "undecided", name : "-", ratio: 17.8},
			]
		},
		{
			"requester": "G1",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 48.1},
				{party: "unitedfuture", name : "박정하", ratio: 27.6},
				{party: "ourrepublican", name : "이강범", ratio: 1.4},
				{party: "etcparty", name : "정상균", ratio: 1.3},
				{party: "noparty", name : "권성중", ratio: 9.7},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
		{
			"requester": "국민일보",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 45.9},
				{party: "unitedfuture", name : "박정하", ratio: 30.6},
				{party: "ourrepublican", name : "이강범", ratio: 4.5},
				{party: "noparty", name : "권성중", ratio: 8.3},
				{party: "undecided", name : "-", ratio: 8.4},
			]
		},
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 44.4},
				{party: "unitedfuture", name : "박정하", ratio: 31.6},
				{party: "ourrepublican", name : "이강범", ratio: 0.6},
				{party: "etcparty", name : "정상균", ratio: 0.4},
				{party: "noparty", name : "권성중", ratio: 9.2},
				{party: "undecided", name : "-", ratio: 13.9},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이광재", ratio: 47.6},
				{party: "unitedfuture", name : "박정하", ratio: 26.6},
				{party: "ourrepublican", name : "이강범", ratio: 0.3},
				{party: "etcparty", name : "정상균", ratio: 1.6},
				{party: "noparty", name : "권성중", ratio: 9.0},
				{party: "undecided", name : "-", ratio: 15.0},
			]
		},
	],
	// 강원 원주을
	"2420203" : [
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "송기헌", ratio: 53.3},
				{party: "unitedfuture", name : "이강후", ratio: 31.4},
				{party: "minsaengdang", name : "안재윤", ratio: 0.4},
				{party: "ourrepublican", name : "현진섭", ratio: 0.8},
				{party: "minjung", name : "이승재", ratio: 0.6},
				{party: "etcparty", name : "정성호", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 12.3},
			]
		},
	],
	// 강원 강릉
	"2420301" : [
		{
			"requester": "강원도민일보",
			"research": "디오피니언",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 501,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 28.0},
				{party: "unitedfuture", name : "홍윤식", ratio: 15.3},
				{party: "minjung", name : "장지창", ratio: 1.1},
				{party: "etcparty", name : "전혁", ratio: 2.3},
				{party: "noparty", name : "권성동", ratio: 31.2},
				{party: "noparty", name : "최명희", ratio: 17.1},
				{party: "undecided", name : "-", ratio: 5.0},
			]
		},
		{
			"requester": "강원일보, KBS춘천, 춘천MBC",
			"research": "코리아리서치",
			"period": "3월 27일 ~ 3월 28일",
			"respondent": 503,
			desc: "표본오차 : 95% 신뢰 수준, ±4.4%p",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 24.8},
				{party: "unitedfuture", name : "홍윤식", ratio: 14.4},
				{party: "minjung", name : "장지창", ratio: 1.0},
				{party: "etcparty", name : "전혁", ratio: 0.4},
				{party: "noparty", name : "권성동", ratio: 24.6},
				{party: "noparty", name : "최명희", ratio: 19.8},
				{party: "undecided", name : "-", ratio: 14.9},
			]
		},
		{
			"requester": "G1",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 30.7},
				{party: "unitedfuture", name : "홍윤식", ratio: 13.3},
				{party: "minjung", name : "장지창", ratio: 0.7},
				{party: "etcparty", name : "전혁", ratio: 0.6},
				{party: "noparty", name : "권성동", ratio: 26.1},
				{party: "noparty", name : "최명희", ratio: 19.6},
				{party: "undecided", name : "-", ratio: 9.0},
			]
		},
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 30.8},
				{party: "unitedfuture", name : "홍윤식", ratio: 14.9},
				{party: "minjung", name : "장지창", ratio: 0.9},
				{party: "etcparty", name : "전혁", ratio: 0.2},
				{party: "noparty", name : "권성동", ratio: 32.4},
				{party: "noparty", name : "최명희", ratio: 12.1},
				{party: "undecided", name : "-", ratio: 8.8},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 32.4},
				{party: "unitedfuture", name : "홍윤식", ratio: 12.4},
				{party: "minjung", name : "장지창", ratio: 1.5},
				{party: "etcparty", name : "전혁", ratio: 0.4},
				{party: "noparty", name : "권성동", ratio: 27.9},
				{party: "noparty", name : "최명희", ratio: 10.7},
				{party: "undecided", name : "-", ratio: 14.8},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김경수", ratio: 33.9},
				{party: "unitedfuture", name : "홍윤식", ratio: 13.6},
				{party: "minjung", name : "장지창", ratio: 0.3},
				// {party: "etcparty", name : "전혁", ratio: 0.4},
				{party: "noparty", name : "권성동", ratio: 29.0},
				{party: "noparty", name : "최명희", ratio: 10.2},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
	],
	// 강원 동해태백삼척정선
	"2420401" : [
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김동완", ratio: 36.2},
				{party: "unitedfuture", name : "이철규", ratio: 40.3},
				{party: "etcparty", name : "이도호", ratio: 1.6},
				{party: "noparty", name : "동다은", ratio: 1.3},
				{party: "noparty", name : "장승호", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 19.6},
			]
		},
	],
	// 강원 속초인제고성양양
	"2420801" : [
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이동기", ratio: 38.1},
				{party: "unitedfuture", name : "이양수", ratio: 42.2},
				{party: "etcparty", name : "김도경", ratio: 1.8},
				{party: "noparty", name : "황정기", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 15.9},
			]
		},
		{
			"requester": "CBS",
			"research": "조원씨앤아이",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이동기", ratio: 41.6},
				{party: "unitedfuture", name : "이양수", ratio: 45.4},
				// {party: "etcparty", name : "김도경", ratio: 0.7},
				// {party: "noparty", name : "황정기", ratio: 26.1},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
	],
	// 강원 홍천횡성영월평창
	"2421402" : [
		{
			"requester": "강원도민일보",
			"research": "디오피니언",
			"period": "3월 28일",
			"respondent": 501,
			desc: "95% 신뢰수준에 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331105721098",
			data: [
				{party: "theminjoo", name : "원경환", ratio: 28.5},
				{party: "unitedfuture", name : "유상범", ratio: 41.0},
				{party: "etcparty", name : "김은희", ratio: 5.6},
				{party: "noparty", name : "조일현", ratio: 13.0},
				{party: "undecided", name : "-", ratio: 11.8},
			]
		},
		{
			"requester": "G1",
			"research": "입소스",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "원경환", ratio: 32.3},
				{party: "unitedfuture", name : "유상범", ratio: 33.6},
				{party: "etcparty", name : "김은희", ratio: 2.0},
				{party: "noparty", name : "조일현", ratio: 19.3},
				{party: "undecided", name : "-", ratio: 12.9},
			]
		},
		{
			"requester": "춘천MBC, 춘천KBS, 강원일보, G1강원민방, 강원도민일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "원경환", ratio: 35.8},
				{party: "unitedfuture", name : "유상범", ratio: 33.1},
				{party: "etcparty", name : "김은희", ratio: 2.0},
				{party: "noparty", name : "조일현", ratio: 11.1},
				{party: "undecided", name : "-", ratio: 17.9},
			]
		},
	],
	// 충북 청주상당
	"2430101" : [
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정정순", ratio: 33.8},
				{party: "unitedfuture", name : "윤갑근", ratio: 29.3},
				{party: "minsaengdang", name : "김홍배", ratio: 1.4},
				{party: "justice21", name : "김종대", ratio: 14.2},
				{party: "undecided", name : "-", ratio: 21.2},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정정순", ratio: 40.4},
				{party: "unitedfuture", name : "윤갑근", ratio: 31.4},
				{party: "minsaengdang", name : "김홍배", ratio: 1.4},
				{party: "justice21", name : "김종대", ratio: 8.3},
				{party: "etcparty", name : "홍경희", ratio: 0.8},
				{party: "undecided", name : "-", ratio: 17.6},
			]
		},
	],
	// 충북 청주서원
	"2430201" : [
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이장섭", ratio: 34.8},
				{party: "unitedfuture", name : "최현호", ratio: 28.8},
				{party: "minsaengdang", name : "이창록", ratio: 3.6},
				{party: "undecided", name : "-", ratio: 31.8},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이장섭", ratio: 46.3},
				{party: "unitedfuture", name : "최현호", ratio: 33.7},
				{party: "minsaengdang", name : "이창록", ratio: 2.4},
				{party: "etcparty", name : "김민수", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
	],
	// 충북 청주흥덕
	"2430202" : [
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 12일 ~ 3월 13일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 49.7},
				{party: "unitedfuture", name : "정우택", ratio: 33.1},
				{party: "minsaengdang", name : "한기수", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 12.1},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "3월 21일 ~ 3월 21일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 44.7},
				{party: "unitedfuture", name : "정우택", ratio: 29.0},
				{party: "minsaengdang", name : "한기수", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 24.2},
			]
		},
		{
			"requester": "MBN, 매일경제신문사 의뢰",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 49.0},
				{party: "unitedfuture", name : "정우택", ratio: 32.3},
				{party: "minsaengdang", name : "한기수", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 13.5},
			]
		},
		{
			"requester": "충청투데이",
			"research": "리얼미터",
			"period": "4월 1일 ~ 4월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 46.4},
				{party: "unitedfuture", name : "정우택", ratio: 35.3},
				{party: "etcparty", name : "서동신", ratio: 1.4},
				{party: "noparty", name : "김양희", ratio: 4.5},
				{party: "undecided", name : "-", ratio: 12.4},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 49.9},
				{party: "unitedfuture", name : "정우택", ratio: 33.2},
				{party: "etcparty", name : "서동신", ratio: 1.0},
				{party: "noparty", name : "김양희", ratio: 2.6},
				{party: "undecided", name : "-", ratio: 13.2},
			]
		},
		{
			"requester": "국민일보,CBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "도종환", ratio: 42.8},
				{party: "unitedfuture", name : "정우택", ratio: 39.2},
				{party: "noparty", name : "김양희", ratio: 6.2},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
	],
	// 충북 청주청원
	"2430601" : [
		{
			"requester": "청주KBS",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "변재일", ratio: 42.2},
				{party: "unitedfuture", name : "김수민", ratio: 27.4},
				{party: "minjung", name : "이명주", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 27.9},
			]
		},
		{
			"requester": "충청투데이",
			"research": "리얼미터",
			"period": "4월 1일 ~ 4월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "변재일", ratio: 50.6},
				{party: "unitedfuture", name : "김수민", ratio: 31.7},
				{party: "minjung", name : "이명주", ratio: 1.0},
				{party: "etcparty", name : "허원", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 14.8},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "변재일", ratio: 52.0},
				{party: "unitedfuture", name : "김수민", ratio: 33.0},
				{party: "minjung", name : "이명주", ratio: 1.7},
				{party: "etcparty", name : "허원", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
	],
	// 충북 충주
	"2430301" : [
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김경욱", ratio: 36.9},
				{party: "unitedfuture", name : "이종배", ratio: 42.1},
				{party: "minsaengdang", name : "최용수", ratio: 2.2},
				{party: "etcparty", name : "김은숙", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 17.5},
			]
		},
	],
	// 충북 제천단양
	"2430401" : [
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이후삼", ratio: 41.6},
				{party: "unitedfuture", name : "엄태영", ratio: 41.7},
				{party: "etcparty", name : "지재환", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 15.6},
			]
		},
	],
	// 충북 보은옥천영동괴산
	"2430701" : [
		{
			"requester": "KBS, 한국일보",
			"research": "한국리서치",
			"period": "3월 12일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "곽상언", ratio: 29.4},
				{party: "unitedfuture", name : "박덕흠", ratio: 43.3},
				{party: "undecided", name : "-", ratio: 22.4},
			]
		},
		{
			"requester": "쿠키뉴스",
			"research": "조원씨앤아이 ",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "곽상언", ratio: 38.4},
				{party: "unitedfuture", name : "박덕흠", ratio: 47.1},
				{party: "undecided", name : "-", ratio: 9.2},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "곽상언", ratio: 33.1},
				{party: "unitedfuture", name : "박덕흠", ratio: 52.9},
				{party: "etcparty", name : "김연원", ratio: 0.7},
				{party: "etcparty", name : "최덕찬", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 12.9},
			]
		},
		{
			"requester": "뉴시스",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "곽상언", ratio: 44.2},
				{party: "unitedfuture", name : "박덕흠", ratio: 45.3},
				{party: "etcparty", name : "김연원", ratio: 1.3},
				{party: "etcparty", name : "최덕찬", ratio: 2.6},
				{party: "undecided", name : "-", ratio: 6.7},
			]
		},
	],
	// 충북 증평진천음성
	"2431002" : [
		{
			"requester": "충청투데이",
			"research": "리얼미터 ",
			"period": "4월 1일 ~ 4월 2일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "임호선", ratio: 40.1},
				{party: "unitedfuture", name : "경대수", ratio: 44.5},
				{party: "etcparty", name : "장정이", ratio: 2.4},
				{party: "undecided", name : "-", ratio: 13.1},
			]
		},
		{
			"requester": "청주KBS",
			"research": "한국갤럽조사연구소",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "임호선", ratio: 40.5},
				{party: "unitedfuture", name : "경대수", ratio: 47.1},
				{party: "etcparty", name : "장정이", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
	],
	// 충남 천안갑
	"2440101" : [
		{
			"requester": "천안신문",
			"research": "세종리서치",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "문진석", ratio: 43.4},
				{party: "unitedfuture", name : "신범철", ratio: 42.4},
				{party: "ourrepublican", name : "정조희", ratio: 1.6},
				{party: "proparknew", name : "조세빈", ratio: 1.1},
				{party: "etcparty", name : "김재원", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 10.1},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "문진석", ratio: 43.1},
				{party: "unitedfuture", name : "신범철", ratio: 38.3},
				{party: "ourrepublican", name : "정조희", ratio: 3.0},
				{party: "proparknew", name : "조세빈", ratio: 2.8},
				{party: "etcparty", name : "김재원", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
	],
	// 충남 천안을
	"2440102" : [
		{
			"requester": "금강일보사",
			"research": "리얼미터",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박완주", ratio: 50.5},
				{party: "unitedfuture", name : "이정만", ratio: 31.6},
				{party: "justice21", name : "박성필", ratio: 3.7},
				{party: "minjung", name : "이영남", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 10.0},
			]
		},
		{
			"requester": "천안신문",
			"research": "세종리서치",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박완주", ratio: 57.1},
				{party: "unitedfuture", name : "이정만", ratio: 30.9},
				{party: "justice21", name : "박성필", ratio: 1.5},
				{party: "minjung", name : "이영남", ratio: 1.3},
				{party: "etcparty", name : "김성용", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 7.7},
			]
		},
	],
	// 충남 천안병
	"2440103" : [
		{
			"requester": "천안신문",
			"research": "세종리서치",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "이정문", ratio: 42.4},
				{party: "unitedfuture", name : "이창수", ratio: 38.6},
				{party: "justice21", name : "황환철", ratio: 3.6},
				{party: "noparty", name : "김종문", ratio: 8.1},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
	],
	// 충남 공주부여청양
	"2440202" : [
		{
			"requester": "",
			"research": "알앤써치 ",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 35.3},
				{party: "unitedfuture", name : "정진석", ratio: 43.5},
				{party: "noparty", name : "김근태", ratio: 8.7},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 24일 ~ 3월 25일",
			"respondent": 500,
			desc: "중앙일보가 입소스에 의뢰해 경기 성남 분당갑, 안양 동안을, 대구 수성갑, 충남 공주·부여·청양, 전남 목포에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(79.2~80.1% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 안양 동안을과 공주·부여·청양은 24~25일 501~502명, 성남 분당갑, 대구 수성갑·목포는 26~27일 501~506명을 조사했고 유·무선 평균 응답률은 지역별로 10.2~ 20.4%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331080319170",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 44.6},
				{party: "unitedfuture", name : "정진석", ratio: 34.4},
				{party: "minsaengdang", name : "전홍기", ratio: 0.7},
				{party: "noparty", name : "김근태", ratio: 7.5},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
		{
			"requester": "",
			"research": "리얼미터",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 48.7},
				{party: "unitedfuture", name : "정진석", ratio: 34.5},
				{party: "minsaengdang", name : "전홍기", ratio: 2.3},
				{party: "noparty", name : "김근태", ratio: 5.8},
				{party: "noparty", name : "정연상", ratio: 1.2},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
		{
			"requester": "금강일보사",
			"research": "세종리서치",
			"period": "3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 46.4},
				{party: "unitedfuture", name : "정진석", ratio: 39.9},
				{party: "minsaengdang", name : "전홍기", ratio: 1.1},
				{party: "etcparty", name : "이홍식", ratio: 0.4},
				{party: "noparty", name : "김근태", ratio: 4.1},
				{party: "noparty", name : "정연상", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 7.0},
			]
		},
		{
			"requester": "대전MBC",
			"research": "코리아리서치인터내셔널",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 42.7},
				{party: "unitedfuture", name : "정진석", ratio: 38.4},
				{party: "minsaengdang", name : "전홍기", ratio: 0.8},
				{party: "etcparty", name : "이홍식", ratio: 0.2},
				{party: "noparty", name : "김근태", ratio: 5.4},
				{party: "noparty", name : "정연상", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 12.1},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 43.8},
				{party: "unitedfuture", name : "정진석", ratio: 37.6},
				{party: "minsaengdang", name : "전홍기", ratio: 0.2},
				{party: "noparty", name : "김근태", ratio: 5.2},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 44.8},
				{party: "unitedfuture", name : "정진석", ratio: 40.4},
				{party: "minsaengdang", name : "전홍기", ratio: 1.2},
				{party: "etcparty", name : "이홍식", ratio: 0.4},
				{party: "noparty", name : "김근태", ratio: 5.6},
				{party: "noparty", name : "정연상", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 44.6},
				{party: "unitedfuture", name : "정진석", ratio: 39.8},
				{party: "minsaengdang", name : "전홍기", ratio: 0.4},
				{party: "etcparty", name : "이홍식", ratio: 1.2},
				{party: "noparty", name : "김근태", ratio: 5.6},
				{party: "noparty", name : "정연상", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 7.4},
			]
		},
		{
			"requester": "문화일보",
			"research": "엠브레인퍼블릭",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "박수현", ratio: 43.7},
				{party: "unitedfuture", name : "정진석", ratio: 34.5},
				{party: "minsaengdang", name : "전홍기", ratio: 0.3},
				// {party: "etcparty", name : "이홍식", ratio: 0.4},
				{party: "noparty", name : "김근태", ratio: 5.2},
				{party: "noparty", name : "정연상", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 15.1},
			]
		},
	],
	// 충남 보령서천
	"2440301" : [
		{
			"requester": "보령시민신문, 뉴스스토리",
			"research": "리서치뷰",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "나소열", ratio: 42.9},
				{party: "unitedfuture", name : "김태흠", ratio: 43.7},
				{party: "undecided", name : "-", ratio: 13.4},
			]
		},
		{
			"requester": "뉴스서천",
			"research": "세종리서치",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "나소열", ratio: 45.3},
				{party: "unitedfuture", name : "김태흠", ratio: 47.3},
				{party: "undecided", name : "-", ratio: 7.4},
			]
		},
		// {
		// 	"requester": "굿모닝충청",
		// 	"research": "리얼미터",
		// 	"period": "4월 6일 ~ 4월 7일",
		// 	"respondent": 500,
		// 	desc: "응답자수 미표기로 인해 500으로 처리",
		// 	link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
		// 	data: [
		// 		{party: "theminjoo", name : "나소열", ratio: 45.3},
		// 		{party: "unitedfuture", name : "김태흠", ratio: 47.3},
		// 		{party: "undecided", name : "-", ratio: 7.4},
		// 	]
		// },
	],
	// 충남 아산갑
	"2440402" : [
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "복기왕", ratio: 46.2},
				{party: "unitedfuture", name : "이명수", ratio: 44.0},
				{party: "etcparty", name : "박현숙", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
		{
			"requester": "굿모닝충청",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "복기왕", ratio: 46.9},
				{party: "unitedfuture", name : "이명수", ratio: 40.6},
				{party: "etcparty", name : "박현숙", ratio: 2.6},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
	],
	// 충남 아산을
	"2440403" : [
	],
	// 충남 서산태안
	"2440501" : [
		{
			"requester": "서산시대, 태안신문, 충남방송",
			"research": "리서치뷰",
			"period": "3월 7일 ~ 3월 8일",
			"respondent": 1,
			desc: "",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "조한기", ratio: 41.6},
				{party: "unitedfuture", name : "성일종", ratio: 43.4},
				{party: "justice21", name : "신현웅", ratio: 4.2},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "서산시대, 태안신문",
			"research": "리서치뷰",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 1,
			desc: "",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "조한기", ratio: 41.5},
				{party: "unitedfuture", name : "성일종", ratio: 50.4},
				{party: "justice21", name : "신현웅", ratio: 1.3},
				{party: "etcparty", name : "김미숙", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 5.9},
			]
		},
		{
			"requester": "TJB대전방송, 충청투데이",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "조한기", ratio: 41.2},
				{party: "unitedfuture", name : "성일종", ratio: 50.0},
				{party: "justice21", name : "신현웅", ratio: 1.7},
				{party: "etcparty", name : "김미숙", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 5.0},
			]
		},
		{
			"requester": "미디어서산,서산신문",
			"research": "비전코리아솔루션즈",
			"period": "4월 6일",
			"respondent": 1,
			desc: "",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "조한기", ratio: 40.0},
				{party: "unitedfuture", name : "성일종", ratio: 52.1},
				{party: "justice21", name : "신현웅", ratio: 1.9},
				{party: "etcparty", name : "김미숙", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 5.4},
			]
		},
		{
			"requester": "굿모닝충청",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "조한기", ratio: 44.7},
				{party: "unitedfuture", name : "성일종", ratio: 45.9},
				{party: "justice21", name : "신현웅", ratio: 1.8},
				{party: "etcparty", name : "김미숙", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 5.4},
			]
		},
	],
	// 충남 논산계룡금산
	"2440901" : [
	],
	// 충남 당진
	"2441601" : [
	],
	// 충남 홍성예산
	"2441301" : [
		{
			"requester": "스트레이트 뉴스",
			"research": "조원씨앤아이",
			"period": "3월 14일 ~ 3월 15일",
			"respondent": 1,
			desc: "",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "김학민", ratio: 34.5},
				{party: "unitedfuture", name : "정진석", ratio: 42.3},
				{party: "undecided", name : "-", ratio: 13.9},
			]
		},
		{
			"requester": "홍성신문",
			"research": "홍성신문",
			"period": "3월 24일 ~ 3월 24일",
			"respondent": 1,
			desc: "",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C#rfn-26",
			data: [
				{party: "theminjoo", name : "김학민", ratio: 35.0},
				{party: "unitedfuture", name : "정진석", ratio: 45.6},
				{party: "undecided", name : "-", ratio: 19.4},
			]
		}
	],
	// 전북 전주갑
	"2450101" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김윤덕", ratio: 61.3},
				{party: "minsaengdang", name : "김광수", ratio: 13.6},
				{party: "justice21", name : "염경석", ratio: 4.9},
				{party: "etcparty", name : "하태윤", ratio: 0.4},
				{party: "etcparty", name : "강명기", ratio: 0.2},
				{party: "noparty", name : "이범석", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 15.4},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김윤덕", ratio: 66.8},
				{party: "justice21", name : "염경석", ratio: 6.5},
				{party: "etcparty", name : "하태윤", ratio: 1.3},
				{party: "etcparty", name : "허성진", ratio: 2.2},
				{party: "noparty", name : "김광수", ratio: 9.7},
				{party: "noparty", name : "이범석", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김윤덕", ratio: 65.3},
				{party: "justice21", name : "염경석", ratio: 6.5},
				{party: "etcparty", name : "하태윤", ratio: 1.1},
				{party: "etcparty", name : "허성진", ratio: 1.4},
				{party: "noparty", name : "김광수", ratio: 14.3},
				{party: "noparty", name : "이범석", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 10.4},
			]
		},
	],
	// 전북 전주을
	"2450102" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상직", ratio: 47.3},
				{party: "unitedfuture", name : "이수진", ratio: 3.4},
				{party: "minsaengdang", name : "조형철", ratio: 1.1},
				{party: "justice21", name : "오형수", ratio: 7.0},
				{party: "etcparty", name : "박정은", ratio: 0.8},
				{party: "etcparty", name : "김주완", ratio: 0.6},
				{party: "noparty", name : "최형재", ratio: 19.6},
				{party: "noparty", name : "성치두", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 17.2},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상직", ratio: 59.6},
				{party: "unitedfuture", name : "이수진", ratio: 3.2},
				{party: "minsaengdang", name : "조형철", ratio: 2.8},
				{party: "justice21", name : "오형수", ratio: 3.3},
				{party: "etcparty", name : "김주완", ratio: 0},
				{party: "noparty", name : "최형재", ratio: 16.1},
				{party: "noparty", name : "성치두", ratio: 2.5},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이상직", ratio: 52.9},
				{party: "unitedfuture", name : "이수진", ratio: 7.1},
				{party: "minsaengdang", name : "조형철", ratio: 1.3},
				{party: "justice21", name : "오형수", ratio: 5.7},
				{party: "etcparty", name : "김주완", ratio: 0.8},
				{party: "noparty", name : "최형재", ratio: 17.3},
				{party: "noparty", name : "성치두", ratio: 2.4},
				{party: "undecided", name : "-", ratio: 12.6},
			]
		},
	],
	// 전북 전주병
	"2450201" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김성주", ratio: 51.5},
				{party: "minsaengdang", name : "정동영", ratio: 30.3},
				{party: "etcparty", name : "최복기", ratio: 0.9},
				{party: "noparty", name : "오세명", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 12.8},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김성주", ratio: 60.1},
				{party: "minsaengdang", name : "정동영", ratio: 27.4},
				{party: "etcparty", name : "최복기", ratio: 2.3},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김성주", ratio: 61.0},
				{party: "minsaengdang", name : "정동영", ratio: 25.2},
				{party: "etcparty", name : "최복기", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김성주", ratio: 56.8},
				{party: "minsaengdang", name : "정동영", ratio: 32.1},
				{party: "etcparty", name : "최복기", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
	],
	// 전북 군산
	"2450301" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "신영대", ratio: 41.1},
				{party: "etcparty", name : "정재은", ratio: 0.5},
				{party: "etcparty", name : "최순정", ratio: 0.2},
				{party: "noparty", name : "김관영", ratio: 44.7},
				{party: "undecided", name : "-", ratio: 11.3},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "신영대", ratio: 48.4},
				{party: "unitedfuture", name : "이근열", ratio: 2.6},
				{party: "etcparty", name : "최순정", ratio: 0.3},
				{party: "noparty", name : "김관영", ratio: 42.4},
				{party: "undecided", name : "-", ratio: 6.3},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "신영대", ratio: 46.1},
				{party: "unitedfuture", name : "이근열", ratio: 1.8},
				{party: "etcparty", name : "최순정", ratio: 0.7},
				{party: "noparty", name : "김관영", ratio: 45.6},
				{party: "undecided", name : "-", ratio: 5.8},
			]
		},
	],
	// 전북 익산갑
	"2450501" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김수흥", ratio: 69.2},
				{party: "unitedfuture", name : "김경안", ratio: 3.1},
				{party: "minsaengdang", name : "고상진", ratio: 4.9},
				{party: "minjung", name : "전권희", ratio: 2.1},
				{party: "etcparty", name : "박순조", ratio: 0.5},
				{party: "etcparty", name : "최영수", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 15.6},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김수흥", ratio: 72.9},
				{party: "unitedfuture", name : "김경안", ratio: 4.6},
				{party: "minsaengdang", name : "고상진", ratio: 8.6},
				{party: "minjung", name : "전권희", ratio: 1.6},
				{party: "etcparty", name : "최영수", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 10.6},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김수흥", ratio: 75.2},
				{party: "unitedfuture", name : "김경안", ratio: 3.6},
				{party: "minsaengdang", name : "고상진", ratio: 7.6},
				{party: "minjung", name : "전권희", ratio: 1.4},
				{party: "etcparty", name : "최영수", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 11.3},
			]
		},
	],
	// 전북 익산을
	"2450502" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "한병도", ratio: 48.1},
				{party: "minsaengdang", name : "조배숙", ratio: 24.5},
				{party: "justice21", name : "권태홍", ratio: 9.0},
				{party: "etcparty", name : "최규석", ratio: 0.7},
				{party: "noparty", name : "배수연", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 14.7},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "한병도", ratio: 61.9},
				{party: "minsaengdang", name : "조배숙", ratio: 19.6},
				{party: "justice21", name : "권태홍", ratio: 5.8},
				{party: "etcparty", name : "최규석", ratio: 0.4},
				{party: "etcparty", name : "이은재", ratio: 1.4},
				{party: "noparty", name : "배수연", ratio: 2.2},
				{party: "undecided", name : "-", ratio: 8.7},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "한병도", ratio: 60.4},
				{party: "minsaengdang", name : "조배숙", ratio: 20.0},
				{party: "justice21", name : "권태홍", ratio: 6.7},
				{party: "etcparty", name : "최규석", ratio: 0.4},
				{party: "etcparty", name : "이은재", ratio: 0.5},
				{party: "noparty", name : "배수연", ratio: 0.7},
				{party: "undecided", name : "-", ratio: 11.2},
			]
		},
	],
	// 전북 정읍고창
	"2450701" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤준병", ratio: 50.1},
				{party: "minsaengdang", name : "유성엽", ratio: 29.5},
				{party: "etcparty", name : "박하웅", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 15.7},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤준병", ratio: 58.7},
				{party: "minsaengdang", name : "유성엽", ratio: 26.6},
				{party: "undecided", name : "-", ratio: 14.7},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤준병", ratio: 64.8},
				{party: "minsaengdang", name : "유성엽", ratio: 25.5},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
	],
	// 전북 남원임실순창
	"2450801" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 13일 ~ 3월 14일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이강래", ratio: 40.8},
				{party: "justice21", name : "정상모", ratio: 3.3},
				{party: "noparty", name : "이용호", ratio: 40.5},
				{party: "noparty", name : "방경채", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 12.0},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이강래", ratio: 42.9},
				{party: "justice21", name : "정상모", ratio: 2.0},
				{party: "noparty", name : "이용호", ratio: 45.2},
				{party: "noparty", name : "방경채", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 9.0},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이강래", ratio: 43.2},
				{party: "justice21", name : "정상모", ratio: 1.9},
				{party: "noparty", name : "이용호", ratio: 47.9},
				{party: "noparty", name : "방경채", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
	],
	// 전북 김제부안
	"2450902" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 43일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이원택", ratio: 56.5},
				{party: "justice21", name : "김경민", ratio: 2.7},
				{party: "etcparty", name : "김성룡", ratio: 1.4},
				{party: "noparty", name : "박정요", ratio: 0.7},
				{party: "noparty", name : "김종회", ratio: 26.3},
				{party: "undecided", name : "-", ratio: 10.2},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이원택", ratio: 60.1},
				{party: "justice21", name : "김경민", ratio: 2.8},
				{party: "etcparty", name : "김성룡", ratio: 1.2},
				{party: "noparty", name : "김종회", ratio: 24.7},
				{party: "undecided", name : "-", ratio: 11.3},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이원택", ratio: 63.4},
				{party: "justice21", name : "김경민", ratio: 2.7},
				// {party: "etcparty", name : "김성룡", ratio: 0},
				{party: "noparty", name : "박정요", ratio: 0},
				{party: "noparty", name : "김종회", ratio: 25.0},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
	],
	// 전북 완주진안무주장수
	"2451001" : [
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 43일 ~ 3월 15일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "안호영", ratio: 58.8},
				{party: "etcparty", name : "장주원", ratio: 1.2},
				{party: "noparty", name : "임정엽", ratio: 27.0},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "전주KBS, 전북일보",
			"research": "한국리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "안호영", ratio: 53.9},
				{party: "unitedfuture", name : "김창도", ratio: 2.1},
				{party: "noparty", name : "임정엽", ratio: 34.0},
				{party: "undecided", name : "-", ratio: 10.0},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "안호영", ratio: 56.5},
				{party: "unitedfuture", name : "김창도", ratio: 2.8},
				{party: "noparty", name : "임정엽", ratio: 33.4},
				{party: "undecided", name : "-", ratio: 7.2},
			]
		},
	],
	// 전남 목포
	"2460101" : [
		{
			"requester": "목포시민신문",
			"research": "모노커뮤니케이션즈",
			"period": "3월 14일 ~ 3월 16일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 41.6},
				{party: "minsaengdang", name : "박지원", ratio: 26.0},
				{party: "justice21", name : "윤소하", ratio: 17.4},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
		{
			"requester": "MBN, 매일경제신문사",
			"research": "알앤써치",
			"period": "3월 23일 ~ 3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 40.1},
				{party: "minsaengdang", name : "박지원", ratio: 29.5},
				{party: "justice21", name : "윤소하", ratio: 14.3},
				{party: "undecided", name : "-", ratio: 9.7},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 506,
			desc: "중앙일보가 입소스에 의뢰해 경기 성남 분당갑, 안양 동안을, 대구 수성갑, 충남 공주·부여·청양, 전남 목포에 거주하는 만 18세 이상 남녀 유권자를 대상으로 무선 가상번호(79.2~80.1% 비율)에 유선 임의전화걸기(RDD)를 결합한 전화면접조사 방식으로 진행했다. 안양 동안을과 공주·부여·청양은 24~25일 501~502명, 성남 분당갑, 대구 수성갑·목포는 26~27일 501~506명을 조사했고 유·무선 평균 응답률은 지역별로 10.2~ 20.4%다. 2020년 2월 말 행정안전부 주민등록 인구 기준으로 지역·성·연령별 가중값(셀 가중)을 부여했고 표본오차는 95% 신뢰 수준에서 최대 ±4.4%포인트",
			link: "https://news.v.daum.net/v/20200331080319170",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 41.2},
				{party: "unitedfuture", name : "황규원", ratio: 1.9},
				{party: "minsaengdang", name : "박지원", ratio: 31.2},
				{party: "justice21", name : "윤소하", ratio: 15.9},
				{party: "undecided", name : "-", ratio: 8.8},
			]
		},
		{
			"requester": "jtbc",
			"research": "(주)한국갤럽조사연구소",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 38.3},
				{party: "minsaengdang", name : "박지원", ratio: 31.0},
				{party: "justice21", name : "윤소하", ratio: 15.0},
				{party: "undecided", name : "-", ratio: 15.2},
			]
		},
		{
			"requester": "광주KBS",
			"research": "한국리서치",
			"period": "3월 31일 ~ 4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 43.0},
				{party: "unitedfuture", name : "황규원", ratio: 1.4},
				{party: "minsaengdang", name : "박지원", ratio: 31.0},
				{party: "justice21", name : "윤소하", ratio: 14.9},
				{party: "undecided", name : "-", ratio: 7.5},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 42.7},
				{party: "unitedfuture", name : "황규원", ratio: 0.4},
				{party: "minsaengdang", name : "박지원", ratio: 34.6},
				{party: "justice21", name : "윤소하", ratio: 11.6},
				{party: "undecided", name : "-", ratio: 10.8},
			]
		},
		{
			"requester": "국민일보, CBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 42.5},
				{party: "unitedfuture", name : "황규원", ratio: 5.3},
				{party: "minsaengdang", name : "박지원", ratio: 30.1},
				{party: "justice21", name : "윤소하", ratio: 17.1},
				{party: "undecided", name : "-", ratio: 5.1},
			]
		},
		{
			"requester": "SBS",
			"research": "입소스",
			"period": "4월 5일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 40.8},
				{party: "unitedfuture", name : "황규원", ratio: 1.7},
				{party: "minsaengdang", name : "박지원", ratio: 34.3},
				{party: "justice21", name : "윤소하", ratio: 16.4},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
		{
			"requester": "YTN",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 48.9},
				{party: "unitedfuture", name : "황규원", ratio: 3.9},
				{party: "minsaengdang", name : "박지원", ratio: 30.2},
				{party: "justice21", name : "윤소하", ratio: 12.0},
				{party: "undecided", name : "-", ratio: 5.0},
			]
		},
		{
			"requester": "동아일보",
			"research": "리서치앤리서치",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김원이", ratio: 39.2},
				{party: "unitedfuture", name : "황규원", ratio: 1.8},
				{party: "minsaengdang", name : "박지원", ratio: 31.3},
				{party: "justice21", name : "윤소하", ratio: 16.3},
				{party: "undecided", name : "-", ratio: 11.5},
			]
		},
	],
	// 전남 여수갑
	"2460201" : [
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "주철현", ratio: 61.8},
				{party: "unitedfuture", name : "심정우", ratio: 3.1},
				{party: "etcparty", name : "장수희", ratio: 0.6},
				{party: "noparty", name : "이용주", ratio: 20.7},
				{party: "undecided", name : "-", ratio: 13.8},
			]
		},
		{
			"requester": "남도일보, LG헬로호남방송,전남CBS",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "주철현", ratio: 57.6},
				{party: "unitedfuture", name : "심정우", ratio: 4.5},
				{party: "etcparty", name : "장수희", ratio: 4.0},
				{party: "noparty", name : "이용주", ratio: 24.3},
				{party: "undecided", name : "-", ratio: 9.6},
			]
		},
	],
	// 전남 여수을
	"2460202" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "(주)한국갤럽조사연구소",
			"period": "2월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김회재", ratio: 44.3},
				{party: "unitedfuture", name : "심정우", ratio: 3.4},
				{party: "minsaengdang", name : "주승용", ratio: 15.8},
				{party: "undecided", name : "-", ratio: 26.5},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김회재", ratio: 63.7},
				{party: "unitedfuture", name : "임동하", ratio: 3.3},
				{party: "justice21", name : "김진수", ratio: 3.2},
				{party: "noparty", name : "권세도", ratio: 11.4},
				{party: "undecided", name : "-", ratio: 18.3},
			]
		},
	],
	// 전남 순천광양곡성구례갑
	"2460403" : [
		{
			"requester": "교차로신문",
			"research": "리얼미터",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "소병철", ratio: 34.2},
				{party: "unitedfuture", name : "천하람", ratio: 3.2},
				{party: "minsaengdang", name : "기도서", ratio: 1.6},
				{party: "justice21", name : "강병택", ratio: 1.8},
				{party: "minjung", name : "김선동", ratio: 7.8},
				{party: "noparty", name : "노관규", ratio: 37.0},
				{party: "undecided", name : "-", ratio: 11.8},
			]
		},
		{
			"requester": "KBS광주",
			"research": "한국리서치",
			"period": "3월 21일 ~ 3월 22일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "소병철", ratio: 35.2},
				{party: "unitedfuture", name : "천하람", ratio: 1.9},
				{party: "minsaengdang", name : "기도서", ratio: 1.0},
				{party: "justice21", name : "강병택", ratio: 1.3},
				{party: "minjung", name : "김선동", ratio: 6.5},
				{party: "etcparty", name : "정동호", ratio: 0.4},
				{party: "etcparty", name : "이정봉", ratio: 0.6},
				{party: "noparty", name : "노관규", ratio: 41.1},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": "남도일보, LG헬로호남방송,전남CBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "소병철", ratio: 41.6},
				{party: "unitedfuture", name : "천하람", ratio: 5.2},
				{party: "minsaengdang", name : "기도서", ratio: 1.3},
				{party: "justice21", name : "강병택", ratio: 2.3},
				{party: "minjung", name : "김선동", ratio: 4.4},
				{party: "etcparty", name : "정동호", ratio: 1.4},
				{party: "etcparty", name : "이정봉", ratio: 1.1},
				{party: "noparty", name : "노관규", ratio: 36.8},
				{party: "undecided", name : "-", ratio: 5.8},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "소병철", ratio: 44.6},
				{party: "unitedfuture", name : "천하람", ratio: 2.6},
				{party: "minsaengdang", name : "기도서", ratio: 1.1},
				{party: "justice21", name : "강병택", ratio: 1.9},
				{party: "minjung", name : "김선동", ratio: 4.7},
				{party: "etcparty", name : "정동호", ratio: 0.2},
				{party: "noparty", name : "노관규", ratio: 35.3},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
	],
	// 전남 순천광양곡성구례을
	"2460702" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "한국갤럽",
			"period": "2월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서동용", ratio: 34.9},
				{party: "justice21", name : "이경자", ratio: 5.7},
				{party: "minjung", name : "유현주", ratio: 2.2},
				{party: "noparty", name : "김광영", ratio: 2.7},
				{party: "noparty", name : "정인화", ratio: 21.1},
				{party: "undecided", name : "-", ratio: 14.8},
			]
		},
		{
			"requester": "남도일보, LG헬로호남방송,전남CBS",
			"research": "리얼미터",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서동용", ratio: 45.4},
				{party: "unitedfuture", name : "김창남", ratio: 6.4},
				{party: "justice21", name : "이경자", ratio: 4.2},
				{party: "minjung", name : "유현주", ratio: 4.4},
				{party: "etcparty", name : "고주석", ratio: 1.5},
				{party: "noparty", name : "정인화", ratio: 28.2},
				{party: "noparty", name : "김종수", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서동용", ratio: 51.9},
				{party: "unitedfuture", name : "김창남", ratio: 3.7},
				{party: "justice21", name : "이경자", ratio: 4.6},
				{party: "minjung", name : "유현주", ratio: 2.1},
				{party: "etcparty", name : "고주석", ratio: 0.2},
				{party: "noparty", name : "정인화", ratio: 23.7},
				{party: "noparty", name : "김종수", ratio: 1.5},
				{party: "undecided", name : "-", ratio: 12.4},
			]
		},
	],
	// 전남 나주화순
	"2460601" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "한국갤럽",
			"period": "2월 24일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "신정훈", ratio: 47.5},
				{party: "minjung", name : "안주용", ratio: 6.7},
				{party: "undecided", name : "-", ratio: 29.6},
			]
		},
	],
	// 전남 담양함평영광장성
	"2462202" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "알앤써치",
			"period": "1월 16일 ~ 1월 19일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이개호", ratio: 65.2},
				{party: "minsaengdang", name : "김연관", ratio: 6.5},
				{party: "undecided", name : "-", ratio: 28.3},
			]
		},
	],
	// 전남 고흥보성장흥강진
	"2461201" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "한국갤럽",
			"period": "2월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김승남", ratio: 42.1},
				{party: "minsaengdang", name : "황주홍", ratio: 25.5},
				{party: "undecided", name : "-", ratio: 18.9},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김승남", ratio: 53.7},
				{party: "minsaengdang", name : "황주홍", ratio: 27.8},
				{party: "noparty", name : "김화진", ratio: 2.6},
				{party: "undecided", name : "-", ratio: 15.9},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김승남", ratio: 52.7},
				{party: "minsaengdang", name : "황주홍", ratio: 28.0},
				{party: "noparty", name : "김화진", ratio: 2.8},
				{party: "undecided", name : "-", ratio: 16.5},
			]
		},
		{
			"requester": "장흥신문",
			"research": "(주)코리아정보리서치",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김승남", ratio: 51.5},
				{party: "minsaengdang", name : "황주홍", ratio: 32.5},
				{party: "noparty", name : "김화진", ratio: 7.1},
				{party: "undecided", name : "-", ratio: 8.9},
			]
		},
	],
	// 전남 해남완도진도
	"2461801" : [
		{
			"requester": "해남신문",
			"research": "리서치뷰",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤재갑", ratio: 57.3},
				{party: "minsaengdang", name : "윤영일", ratio: 28.6},
				{party: "etcparty", name : "강상범", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤재갑", ratio: 59.2},
				{party: "minsaengdang", name : "윤영일", ratio: 25.8},
				{party: "etcparty", name : "강상범", ratio: 0.9},
				{party: "undecided", name : "-", ratio: 14.0},
			]
		},
		{
			"requester": "전주MBC, JTV 전주방송, 전북도민일보, 전라일보",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "윤재갑", ratio: 62.0},
				{party: "minsaengdang", name : "윤영일", ratio: 24.5},
				{party: "etcparty", name : "강상범", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 11.8},
			]
		},
	],
	// 전남 영암무안신안
	"2462101" : [
		{
			"requester": "뉴시스광주전남, 무등일보, 전남일보, 광주MBC, 여수MBC, 목포MBC 의뢰",
			"research": "한국갤럽",
			"period": "2월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서삼석", ratio: 55.4},
				{party: "minsaengdang", name : "이윤석", ratio: 10.9},
				{party: "noparty", name : "김팔봉", ratio: 1.6},
				{party: "noparty", name : "임흥빈", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 15.6},
			]
		},
		{
			"requester": "무등일보, 뉴시스광주전남, 광주·여수·목포MBC",
			"research": "한국갤럽조사연구소",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서삼석", ratio: 74.3},
				{party: "unitedfuture", name : "이인호", ratio: 2.6},
				{party: "minsaengdang", name : "이윤석", ratio: 15.0},
				{party: "undecided", name : "-", ratio: 8.1},
			]
		},
	],
	// 경북 포항북구
	"2470101" : [
		{
			"requester": "NSP통신 대구경북본부, 뉴스앤포항, 영남이코노믹",
			"research": "코리아정보리서치",
			"period": "3월 30일",
			"respondent": 501,
			desc: "포항시 북구 선거구에 거주하는 만18세 이상 남녀 501명을 대상(응답률 4.7%.표본오차 95% 신뢰수준 ±4.4%포인트)으로 이뤄졌으며, 설문지를 이용한 휴대전화 가상번호 44%, 유선전화 RDD 56% 자동응답 방식으로 진행됐다.",
			link: "http://www.nspna.com/news/?mode=view&newsid=420464",
			data: [
				{party: "theminjoo", name : "오중기", ratio: 20.2},
				{party: "unitedfuture", name : "김정재", ratio: 61.4},
				{party: "justice21", name : "박창호", ratio: 4.1},
				{party: "etcparty", name : "박건우", ratio: 3.5},
				{party: "undecided", name : "-", ratio: 10.8},
			]
		},
		{
			"requester": "매일신문·TBC",
			"research": "소셜데이타리서치",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 1011,
			desc: "매일신문·TBC 의뢰로 소셜데이타리서치가 2020년 3월 28~30일 사흘 동안 포항북에 거주하는 만 18세 이상 남여 1천11명을 대상으로 ARS 여론조사 방식(무선전화 66.8%, 유선전화 31.0% RDD 방식)과 무선전화면접 2.2%로 진행했다. 유선은 무작위 생성 전화번호로, 무선은 통신 3사가 제공한 가상번호 표본을 추출했다. 표본오차 ±3.1%포인트(95% 신뢰수준)",
			link: "https://news.naver.com/main/election/nation2020/news/read.nhn?mode=LSD&mid=sec&sid1=165&oid=088&aid=0000641576",
			data: [
				{party: "theminjoo", name : "오중기", ratio: 27.4},
				{party: "unitedfuture", name : "김정재", ratio: 59.8},
				{party: "justice21", name : "박창호", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 8.5},
			]
		},
		{
			"requester": "포항MBC",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오중기", ratio: 26.9},
				{party: "unitedfuture", name : "김정재", ratio: 53.1},
				{party: "justice21", name : "박창호", ratio: 3.9},
				{party: "etcparty", name : "박건우", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 14.4},
			]
		},
	],
	// 경북 포항남울릉
	"2470201" : [
		{
			"requester": "NSP통신 대구경북본부, 뉴스앤포항, 영남이코노믹",
			"research": "코리아정보리서치",
			"period": "3월 12일 ~ 3월 13일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "http://www.nspna.com/news/?mode=view&newsid=420464",
			data: [
				{party: "theminjoo", name : "허대만", ratio: 20.6},
				{party: "unitedfuture", name : "김병욱", ratio: 15.5},
				{party: "noparty", name : "박승호", ratio: 32.3},
				{party: "undecided", name : "-", ratio: 25.8},
			]
		},
		{
			"requester": "매일신문·TBC",
			"research": "소셜데이타리서치",
			"period": "3월 28일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허대만", ratio: 27.8},
				{party: "unitedfuture", name : "김병욱", ratio: 44.2},
				{party: "minjung", name : "박승억", ratio: 1.8},
				{party: "noparty", name : "박승호", ratio: 13.7},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
		{
			"requester": "미래한국연구소,V.O.K(Voice of Korea)",
			"research": "피플네트웍스",
			"period": "4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허대만", ratio: 29.2},
				{party: "unitedfuture", name : "김병욱", ratio: 45.4},
				{party: "noparty", name : "박승호", ratio: 15.2},
				{party: "undecided", name : "-", ratio: 7.1},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허대만", ratio: 30.1},
				{party: "unitedfuture", name : "김병욱", ratio: 53.2},
				{party: "minjung", name : " 박승억", ratio: 1.6},
				{party: "noparty", name : "박승호", ratio: 12.6},
				{party: "undecided", name : "-", ratio: 1.8},
			]
		},
		{
			"requester": "포항MBC",
			"research": "리얼미터",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "허대만", ratio: 31.4},
				{party: "unitedfuture", name : "김병욱", ratio: 36.0},
				{party: "minjung", name : " 박승억", ratio: 1.1},
				{party: "etcparty", name : " 박덕춘", ratio: 0.7},
				{party: "noparty", name : "박승호", ratio: 11.1},
				{party: "undecided", name : "-", ratio: 19.7},
			]
		},
	],
	// 경북 경주
	"2470401" : [
		{
			"requester": "안동MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정다은", ratio: 9.1},
				{party: "unitedfuture", name : "김석기", ratio: 48.6},
				{party: "minsaengdang", name : "김보성", ratio: 2.0},
				{party: "justice21", name : "권영국", ratio: 4.2},
				{party: "etcparty", name : "김덕현", ratio: 1.4},
				{party: "noparty", name : "정종복", ratio: 21.3},
				{party: "noparty", name : "김일윤", ratio: 3.3},
				{party: "undecided", name : "-", ratio: 10.1},
			]
		},
		{
			"requester": "포항mbc",
			"research": "리얼미터",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정다은", ratio: 12.5},
				{party: "unitedfuture", name : "김석기", ratio: 44.8},
				{party: "minsaengdang", name : "김보성", ratio: 0.6},
				{party: "justice21", name : "권영국", ratio: 7.9},
				{party: "etcparty", name : "김덕현", ratio: 0.7},
				{party: "noparty", name : "정종복", ratio: 14.3},
				{party: "noparty", name : "김일윤", ratio: 3.2},
				{party: "undecided", name : "-", ratio: 16.1},
			]
		},
	],
	// 경북 김천
	"2470501" : [
	],
	// 경북 안동예천
	"2470601" : [
		{
			"requester": "매일신문·TBC",
			"research": "소셜데이타리서치",
			"period": "3월 29일 ~ 3월 30일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이삼걸", ratio: 21.0},
				{party: "unitedfuture", name : "김형동", ratio: 35.8},
				{party: "ourrepublican", name : "박인우", ratio: 1.5},
				{party: "noparty", name : "권택기", ratio: 25.1},
				{party: "noparty", name : "권오을", ratio: 9.4},
				{party: "undecided", name : "-", ratio: 6.3},
			]
		},
		{
			"requester": "경안일보",
			"research": "경북리서치",
			"period": "3월 26일 ~ 3월 27일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이삼걸", ratio: 12.1},
				{party: "unitedfuture", name : "김형동", ratio: 31.6},
				{party: "ourrepublican", name : "박인우", ratio: 1.8},
				{party: "noparty", name : "권택기", ratio: 28.5},
				{party: "noparty", name : "권오을", ratio: 8.6},
				{party: "undecided", name : "-", ratio: 17.4},
			]
		},
		{
			"requester": "경북인터넷방송",
			"research": "경북인터넷방송",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이삼걸", ratio: 20.6},
				{party: "unitedfuture", name : "김형동", ratio: 25.6},
				{party: "ourrepublican", name : "박인우", ratio: 6.3},
				{party: "noparty", name : "권택기", ratio: 26.2},
				{party: "noparty", name : "권오을", ratio: 13.0},
				{party: "undecided", name : "-", ratio: 6.4},
			]
		},
		{
			"requester": "안동MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이삼걸", ratio: 17.6},
				{party: "unitedfuture", name : "김형동", ratio: 34.8},
				{party: "ourrepublican", name : "박인우", ratio: 1.1},
				{party: "etcparty", name : "신효주", ratio: 0.8},
				{party: "noparty", name : "권택기", ratio: 22.3},
				{party: "noparty", name : "권오을", ratio: 9.3},
				{party: "undecided", name : "-", ratio: 14.1},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이삼걸", ratio: 17.7},
				{party: "unitedfuture", name : "김형동", ratio: 43.7},
				{party: "ourrepublican", name : "박인우", ratio: 2.1},
				// {party: "etcparty", name : "신효주", ratio: 0.8},
				{party: "noparty", name : "권택기", ratio: 24.6},
				{party: "noparty", name : "권오을", ratio: 7.1},
				{party: "undecided", name : "-", ratio: 4.0},
			]
		},
	],
	// 경북 구미갑
	"2470701" : [
	],
	// 경북 구미을
	"2470702" : [
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김현권", ratio: 29.3},
				{party: "unitedfuture", name : "김영식", ratio: 49.1},
				{party: "noparty", name : "김봉교", ratio: 14.7},
				{party: "undecided", name : "-", ratio: 5.5},
			]
		},
	],
	// 경북 영주영양봉화울진
	"2470802" : [
		{
			"requester": "영양신문",
			"research": "코리아정보리서치",
			"period": "3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황재선", ratio: 9.7},
				{party: "unitedfuture", name : "박형수", ratio: 49.5},
				{party: "etcparty", name : "김형규", ratio: 2.5},
				{party: "noparty", name : "장윤석", ratio: 21.0},
				{party: "undecided", name : "-", ratio: 15.6},
			]
		},
		{
			"requester": "경안일보",
			"research": "경북리서치",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황재선", ratio: 12.3},
				{party: "unitedfuture", name : "박형수", ratio: 47.0},
				{party: "etcparty", name : "김형규", ratio: 3.2},
				{party: "noparty", name : "장윤석", ratio: 20.8},
				{party: "undecided", name : "-", ratio: 14.2},
			]
		},
		{
			"requester": "(주)경북미디어 영양신문",
			"research": "코리아정보리서치 중부본부",
			"period": "4월 2일 ~ 4월 3일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황재선", ratio: 14.3},
				{party: "unitedfuture", name : "박형수", ratio: 45.7},
				{party: "etcparty", name : "김형규", ratio: 4.3},
				{party: "noparty", name : "장윤석", ratio: 19.5},
				{party: "undecided", name : "-", ratio: 16.2},
			]
		},
		{
			"requester": "안동MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황재선", ratio: 16.8},
				{party: "unitedfuture", name : "박형수", ratio: 44.7},
				{party: "etcparty", name : "김형규", ratio: 1.0},
				{party: "noparty", name : "장윤석", ratio: 18.5},
				{party: "undecided", name : "-", ratio: 19.1},
			]
		},
	],
	// 경북 영천
	"2470901" : [
	],
	// 경북 상주문경
	"2471002" : [
		{
			"requester": "(주)경안일보",
			"research": "주식회사 경북리서치",
			"period": "4월 1일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정용운", ratio: 12.1},
				{party: "unitedfuture", name : "임이자", ratio: 46.8},
				{party: "etcparty", name : "이언우", ratio: 7.7},
				{party: "noparty", name : "이한성", ratio: 17.2},
				{party: "undecided", name : "-", ratio: 16.1},
			]
		},
		{
			"requester": "안동MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정용운", ratio: 14.9},
				{party: "unitedfuture", name : "임이자", ratio: 51.7},
				{party: "etcparty", name : "이언우", ratio: 1.4},
				{party: "noparty", name : "이한성", ratio: 15.2},
				{party: "undecided", name : "-", ratio: 16.7},
			]
		},
	],
	// 경북 경산
	"2471302" : [
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "전상헌", ratio: 26.3},
				{party: "unitedfuture", name : "윤두현", ratio: 58.7},
				{party: "minjung", name : "남수정", ratio: 3.7},
				{party: "noparty", name : "이권우", ratio: 6.8},
				{party: "undecided", name : "-", ratio: 2.8},
			]
		},
	],
	// 경북 군위의성청송영덕
	"2471902" : [
		{
			"requester": "군위군민신문",
			"research": "코리아정보리서치",
			"period": "3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강부송", ratio: 10.5},
				{party: "unitedfuture", name : "김희국", ratio: 56.6},
				{party: "etcparty", name : "이광희", ratio: 3.5},
				{party: "undecided", name : "-", ratio: 29.4},
			]
		},
		{
			"requester": "안동MBC",
			"research": "코리아리서치인터내셔널",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "강부송", ratio: 16.3},
				{party: "unitedfuture", name : "김희국", ratio: 58.9},
				{party: "etcparty", name : "이광희", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 23.0},
			]
		},
	],
	// 경북 고령성주칠곡
	"2471701" : [
		{
			"requester": "매일신문·TBC",
			"research": "소셜데이타리서치",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "장세호", ratio: 23.9},
				{party: "unitedfuture", name : "정희용", ratio: 51.0},
				{party: "noparty", name : "김현기", ratio: 15.4},
				{party: "undecided", name : "-", ratio: 8.0},
			]
		},
		{
			"requester": "미래한국연구소, VOK",
			"research": "피플네트웍스",
			"period": "3월 25일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "장세호", ratio: 22.8},
				{party: "unitedfuture", name : "정희용", ratio: 48.6},
				{party: "etcparty", name : "정한석", ratio: 4.7},
				{party: "noparty", name : "김현기", ratio: 13.6},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
		{
			"requester": "영남일보, KBS대구, 대구CBS",
			"research": "에이스리서치",
			"period": "4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "장세호", ratio: 24.8},
				{party: "unitedfuture", name : "정희용", ratio: 53.7},
				// {party: "etcparty", name : "정한석", ratio: 4.7},
				{party: "noparty", name : "김현기", ratio: 18.9},
				{party: "undecided", name : "-", ratio: 1.3},
			]
		},
	],
	// 경남 창원의창
	"2480101" : [
	],
	// 경남 창원성산
	"2480102" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "이흥석", ratio: 19.6},
				{party: "unitedfuture", name : "강기윤", ratio: 46.2},
				{party: "justice21", name : "여영국", ratio: 19.8},
				{party: "ourrepublican", name : "진순정", ratio: 1.2},
				{party: "minjung", name : "석영철", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 8.3},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이흥석", ratio: 18.1},
				{party: "unitedfuture", name : "강기윤", ratio: 43.9},
				{party: "minsaengdang", name : "구명회", ratio: 0.7},
				{party: "justice21", name : "여영국", ratio: 22.9},
				{party: "minjung", name : "석영철", ratio: 4.5},
				{party: "etcparty", name : "조규필", ratio: 4.2},
				{party: "undecided", name : "-", ratio: 7.7},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이흥석", ratio: 24.9},
				{party: "unitedfuture", name : "강기윤", ratio: 42.8},
				{party: "minsaengdang", name : "구명회", ratio: 1.8},
				{party: "justice21", name : "여영국", ratio: 24.5},
				{party: "minjung", name : "석영철", ratio: 2.4},
				{party: "etcparty", name : "조규필", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 3.0},
			]
		},
		{
			"requester": "KBS 창원총국",
			"research": "(주)한국리서치",
			"period": "4월 5일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "이흥석", ratio: 21.4},
				{party: "unitedfuture", name : "강기윤", ratio: 31.0},
				{party: "minsaengdang", name : "구명회", ratio: 0.2},
				{party: "justice21", name : "여영국", ratio: 31.3},
				{party: "minjung", name : "석영철", ratio: 1.8},
				{party: "etcparty", name : "조규필", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 13.8},
			]
		},
	],
	// 경남 창원마산합포
	"2480201" : [
	],
	// 경남 창원마산회원
	"2480202" : [
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "하귀남", ratio: 32.9},
				{party: "unitedfuture", name : "윤한홍", ratio: 53.0},
				{party: "ourrepublican", name : "조민기", ratio: 1.6},
				{party: "etcparty", name : "허양희", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 10.6},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "하귀남", ratio: 33.5},
				{party: "unitedfuture", name : "윤한홍", ratio: 51.5},
				{party: "ourrepublican", name : "조민기", ratio: 2.0},
				{party: "etcparty", name : "허양희", ratio: 2.1},
				{party: "undecided", name : "-", ratio: 10.9},
			]
		},
		{
			"requester": "미래한국연구소,V.O.K(Voice of Korea)",
			"research": "피플네트웍스",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "하귀남", ratio: 39.0},
				{party: "unitedfuture", name : "윤한홍", ratio: 49.5},
				{party: "ourrepublican", name : "조민기", ratio: 2.3},
				{party: "etcparty", name : "허양희", ratio: 2.0},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
	],
	// 경남 창원진해
	"2480401" : [
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황기철", ratio: 37.0},
				{party: "unitedfuture", name : "이달곤", ratio: 43.0},
				{party: "justice21", name : "조광호", ratio: 3.1},
				{party: "etcparty", name : "유재철", ratio: 3.0},
				{party: "undecided", name : "-", ratio: 13.9},
			]
		},
		{
			"requester": "KBS 창원총국",
			"research": "(주)한국리서치",
			"period": "4월 5일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황기철", ratio: 45.9},
				{party: "unitedfuture", name : "이달곤", ratio: 38.6},
				{party: "justice21", name : "조광호", ratio: 2.1},
				{party: "etcparty", name : "유재철", ratio: 2.0},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황기철", ratio: 39.6},
				{party: "unitedfuture", name : "이달곤", ratio: 45.1},
				{party: "justice21", name : "조광호", ratio: 5.1},
				{party: "etcparty", name : "유재철", ratio: 1.7},
				{party: "undecided", name : "-", ratio: 8.5},
			]
		},
	],
	// 경남 진주갑
	"2480301" : [
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정영훈", ratio: 26.2},
				{party: "unitedfuture", name : "박대출", ratio: 51.0},
				{party: "minjung", name : "김준형", ratio: 3.6},
				{party: "etcparty", name : "오필남", ratio: 1.0},
				{party: "noparty", name : "김유근", ratio: 2.4},
				{party: "noparty", name : "최승제", ratio: 3.6},
				{party: "undecided", name : "-", ratio: 12.2},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "정영훈", ratio: 32.6},
				{party: "unitedfuture", name : "박대출", ratio: 49.1},
				{party: "minjung", name : "김준형", ratio: 3.2},
				{party: "etcparty", name : "오필남", ratio: 1.6},
				{party: "noparty", name : "김유근", ratio: 3.1},
				{party: "noparty", name : "최승제", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 7.3},
			]
		},
	],
	// 경남 진주을
	"2480302" : [
		{
			"requester": "경남미디어",
			"research": "리얼미터",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "한경호", ratio: 31.0},
				{party: "unitedfuture", name : "강민국", ratio: 46.5},
				{party: "ourrepublican", name : "김동우", ratio: 2.2},
				{party: "etcparty", name : "김봉준", ratio: 1.4},
				{party: "noparty", name : "이창희", ratio: 7.7},
				{party: "undecided", name : "-", ratio: 11.1},
			]
		},
		{
			"requester": "KBS 창원총국",
			"research": "(주)한국리서치",
			"period": "4월 5일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "한경호", ratio: 30.4},
				{party: "unitedfuture", name : "강민국", ratio: 42.3},
				{party: "ourrepublican", name : "김동우", ratio: 1.6},
				{party: "etcparty", name : "김봉준", ratio: 1.5},
				{party: "noparty", name : "이창희", ratio: 9.8},
				{party: "undecided", name : "-", ratio: 14.5},
			]
		},
	],
	// 경남 통영고성
	"2480501" : [
		{
			"requester": "창원일보, 미래한국연구소",
			"research": "피플네트웍스",
			"period": "2019년 5월 30일 ~ 5월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "양문석", ratio: 35.1},
				{party: "unitedfuture", name : "정점식", ratio: 48.1},
				{party: "undecided", name : "-", ratio: 10.6},
			]
		},
	],
	// 경남 사천남해하동
	"2480702" : [
		{
			"requester": "MBC경남",
			"research": "KSOI",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황인성", ratio: 30.9},
				{party: "unitedfuture", name : "하영제", ratio: 51.0},
				{party: "etcparty", name : "고외순", ratio: 2.1},
				{party: "noparty", name : "정승재", ratio: 3.3},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "황인성", ratio: 34.0},
				{party: "unitedfuture", name : "하영제", ratio: 52.0},
				{party: "etcparty", name : "고외순", ratio: 2.1},
				{party: "noparty", name : "정승재", ratio: 1.6},
				{party: "undecided", name : "-", ratio: 10.3},
			]
		},
	],
	// 경남 김해갑
	"2480801" : [
	],
	// 경남 김해을
	"2480802" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "김정호", ratio: 40.6},
				{party: "unitedfuture", name : "장기표", ratio: 35.5},
				{party: "justice21", name : "배주임", ratio: 5.0},
				{party: "noparty", name : "이영철", ratio: 4.0},
				{party: "undecided", name : "-", ratio: 12.5},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김정호", ratio: 45.1},
				{party: "unitedfuture", name : "장기표", ratio: 36.4},
				{party: "justice21", name : "배주임", ratio: 1.1},
				{party: "etcparty", name : "안종규", ratio: 0.5},
				{party: "noparty", name : "이영철", ratio: 5.5},
				{party: "undecided", name : "-", ratio: 11.4},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김정호", ratio: 39.8},
				{party: "unitedfuture", name : "장기표", ratio: 41.7},
				{party: "justice21", name : "배주임", ratio: 5.8},
				{party: "etcparty", name : "안종규", ratio: 0.9},
				{party: "noparty", name : "이영철", ratio: 3.3},
				{party: "undecided", name : "-", ratio: 8.5},
			]
		},
		{
			"requester": "중앙일보",
			"research": "입소스 주식회사",
			"period": "4월 5일 ~ 4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김정호", ratio: 46.8},
				{party: "unitedfuture", name : "장기표", ratio: 27.8},
				{party: "justice21", name : "배주임", ratio: 6.0},
				{party: "etcparty", name : "안종규", ratio: 0.9},
				{party: "noparty", name : "이영철", ratio: 5.7},
				{party: "undecided", name : "-", ratio: 12.7},
			]
		},
	],
	// 경남 밀양의령함안창녕
	"2480901" : [
	],
	// 경남 거제
	"2481001" : [
		{
			"requester": "타임라인",
			"research": "한국사회여론연구소",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "문상모", ratio: 24.3},
				{party: "unitedfuture", name : "서일준", ratio: 50.3},
				{party: "ourrepublican", name : "박재행", ratio: 1.2},
				{party: "etcparty", name : "이태재", ratio: 0.6},
				{party: "noparty", name : "김해연", ratio: 10.1},
				{party: "noparty", name : "염용하", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 12.4},
			]
		},
		{
			"requester": "경남매일,미래한국연구소,V.O.K(Voice of Korea)",
			"research": "피플네트웍스",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "문상모", ratio: 36.7},
				{party: "unitedfuture", name : "서일준", ratio: 42.7},
				{party: "ourrepublican", name : "박재행", ratio: 2.1},
				{party: "etcparty", name : "이태재", ratio: 1.5},
				{party: "noparty", name : "김해연", ratio: 9.1},
				{party: "noparty", name : "염용하", ratio: 1.1},
				{party: "undecided", name : "-", ratio: 6.7},
			]
		},
	],
	// 경남 양산갑
	"2481402" : [
	],
	// 경남 양산을
	"2481403" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 41.2},
				{party: "unitedfuture", name : "나동연", ratio: 40.3},
				{party: "justice21", name : "권현우", ratio: 4.3},
				{party: "undecided", name : "-", ratio: 9.9},
			]
		},
		{
			"requester": "",
			"research": "싸이리서치(SAI)",
			"period": "3월 28일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 36.1},
				{party: "unitedfuture", name : "나동연", ratio: 43.8},
				{party: "justice21", name : "권현우", ratio: 4.0},
				{party: "undecided", name : "-", ratio: 13.3},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 43.7},
				{party: "unitedfuture", name : "나동연", ratio: 43.0},
				{party: "justice21", name : "권현우", ratio: 2.6},
				{party: "etcparty", name : "최서영", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 8.8},
			]
		},
		{
			"requester": "부산MBC",
			"research": "한길리서치센타",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 42.2},
				{party: "unitedfuture", name : "나동연", ratio: 45.5},
				{party: "justice21", name : "권현우", ratio: 1.8},
				{party: "etcparty", name : "최서영", ratio: 1.9},
				{party: "undecided", name : "-", ratio: 8.6},
			]
		},
		{
			"requester": " MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 40.1},
				{party: "unitedfuture", name : "나동연", ratio: 46.2},
				{party: "justice21", name : "권현우", ratio: 2.9},
				{party: "etcparty", name : "최서영", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 9.4},
			]
		},
		{
			"requester": "국제신문",
			"research": "폴리컴",
			"period": "4월 6일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 41.2},
				{party: "unitedfuture", name : "나동연", ratio: 48.6},
				{party: "justice21", name : "권현우", ratio: 2.0},
				{party: "undecided", name : "-", ratio: 6.1},
			]
		},
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 40.6},
				{party: "unitedfuture", name : "나동연", ratio: 45.6},
				{party: "justice21", name : "권현우", ratio: 3.1},
				{party: "undecided", name : "-", ratio: 7.1},
			]
		},
		{
			"requester": "뉴시스",
			"research": "리얼미터",
			"period": "4월 7일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "김두관", ratio: 47.2},
				{party: "unitedfuture", name : "나동연", ratio: 42.6},
				{party: "justice21", name : "권현우", ratio: 1.7},
				{party: "etcparty", name : "최서영", ratio: 2.0},
				{party: "undecided", name : "-", ratio: 6.3},
			]
		},
	],
	// 경남 산청함양거창합천
	"2481901" : [
		{
			"requester": "부산일보",
			"research": "한국사회여론연구소",
			"period": "3월 25일 ~ 3월 26일",
			"respondent": 3646,
			desc: "부산일보 여론조사 전문기관인 한국사회여론연구소(KSOI)에 의뢰해 25~26일 서부산 3개·경남 4개 지역구를 대상으로 실시한 여론조사(만 18세 이상 남녀 3646명 대상, 표본오차는 95% 신뢰수준 ±4.2~4.4%P",
			link: "http://www.busan.com/view/busan/view.php?code=2020033019363397504",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 16.4},
				{party: "unitedfuture", name : "강석진", ratio: 35.7},
				{party: "ourrepublican", name : "박영주", ratio: 2.2},
				{party: "minjung", name : "전성기", ratio: 2.6},
				{party: "noparty", name : "김태호", ratio: 31.5},
				{party: "undecided", name : "-", ratio: 9.1},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "3월 29일 ~ 3월 29일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 12.5},
				{party: "unitedfuture", name : "강석진", ratio: 35.7},
				{party: "minsaengdang", name : "김운향", ratio: 0.7},
				{party: "ourrepublican", name : "박영주", ratio: 2.3},
				{party: "minjung", name : "전성기", ratio: 1.6},
				{party: "etcparty", name : "김태영", ratio: 2.8},
				{party: "noparty", name : "김태호", ratio: 34.9},
				{party: "undecided", name : "-", ratio: 9.5},
			]
		},
		{
			"requester": "미래한국연구소, VOK",
			"research": "피플네트웍스",
			"period": "3월 31일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 16.2},
				{party: "unitedfuture", name : "강석진", ratio: 37.1},
				{party: "minsaengdang", name : "김운향", ratio: 3.2},
				{party: "ourrepublican", name : "박영주", ratio: 1.3},
				{party: "minjung", name : "전성기", ratio: 1.5},
				{party: "etcparty", name : "김태영", ratio: 1.8},
				{party: "noparty", name : "김태호", ratio: 31.7},
				{party: "undecided", name : "-", ratio: 6.8},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 2일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 16.6},
				{party: "unitedfuture", name : "강석진", ratio: 36.5},
				{party: "minsaengdang", name : "김운향", ratio: 0.2},
				{party: "ourrepublican", name : "박영주", ratio: 0.4},
				{party: "minjung", name : "전성기", ratio: 0.8},
				{party: "etcparty", name : "김태영", ratio: 0.6},
				{party: "noparty", name : "김태호", ratio: 29.4},
				{party: "undecided", name : "-", ratio: 15.6},
			]
		},
		{
			"requester": "MBC경남",
			"research": "한국사회여론연구소",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 12.9},
				{party: "unitedfuture", name : "강석진", ratio: 39.2},
				{party: "minsaengdang", name : "김운향", ratio: 0.9},
				{party: "ourrepublican", name : "박영주", ratio: 1.9},
				{party: "minjung", name : "전성기", ratio: 1.9},
				{party: "etcparty", name : "김태영", ratio: 1.1},
				{party: "noparty", name : "김태호", ratio: 35.9},
				{party: "undecided", name : "-", ratio: 6.2},
			]
		},
		{
			"requester": "미래한국연구소, VOK",
			"research": "피플네트웍스",
			"period": "4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "서필상", ratio: 16.0},
				{party: "unitedfuture", name : "강석진", ratio: 38.1},
				{party: "minsaengdang", name : "김운향", ratio: 1.1},
				// {party: "ourrepublican", name : "박영주", ratio: 1.3},
				// {party: "minjung", name : "전성기", ratio: 1.5},
				// {party: "etcparty", name : "김태영", ratio: 1.8},
				{party: "noparty", name : "김태호", ratio: 37.9},
				{party: "undecided", name : "-", ratio: 5.2},
			]
		},
	],
	// 제주 제주갑
	"2490101" : [
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "송재호", ratio: 34.3},
				{party: "unitedfuture", name : "장성철", ratio: 27.6},
				{party: "minsaengdang", name : "양길현", ratio: 0.5},
				{party: "justice21", name : "고병수", ratio: 5.7},
				{party: "ourrepublican", name : "문대탄", ratio: 1.0},
				{party: "noparty", name : "박희수", ratio: 12.6},
				{party: "undecided", name : "-", ratio: 15.3},
			]
		},
		{
			"requester": "헤드라인제주, KCTV 제주방송, 제주일보, 제주투데이",
			"research": "한국갤럽",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 505,
			desc: "표본오차는 95% 신뢰수준에서 ±2.5%포인트(제주시 갑 ±4.4%포인트, 제주시을 ±4.4%포인트, 서귀포시 ±4.4%포인트)",
			link: "http://www.headlinejeju.co.kr/news/articleView.html?idxno=413395",
			data: [
				{party: "theminjoo", name : "송재호", ratio: 34.8},
				{party: "unitedfuture", name : "장성철", ratio: 28.0},
				{party: "justice21", name : "고병수", ratio: 6.4},
				{party: "ourrepublican", name : "문대탄", ratio: 0.4},
				{party: "noparty", name : "박희수", ratio: 7.0},
				{party: "noparty", name : "임효준", ratio: 0.0},
				{party: "noparty", name : "현용식", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 23.2},
			]
		},
		{
			"requester": "제민일보, 한라일보, JIBS",
			"research": "리얼미터",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "송재호", ratio: 39.6},
				{party: "unitedfuture", name : "장성철", ratio: 29.6},
				{party: "justice21", name : "고병수", ratio: 5.9},
				{party: "ourrepublican", name : "문대탄", ratio: 1.0},
				{party: "noparty", name : "박희수", ratio: 7.3},
				{party: "noparty", name : "임효준", ratio: 0.3},
				{party: "noparty", name : "현용식", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 16.1},
			]
		},
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "송재호", ratio: 43.9},
				{party: "unitedfuture", name : "장성철", ratio: 29.1},
				{party: "justice21", name : "고병수", ratio: 7.1},
				{party: "ourrepublican", name : "문대탄", ratio: 0.9},
				{party: "noparty", name : "박희수", ratio: 7.3},
				{party: "noparty", name : "임효준", ratio: 0.2},
				{party: "noparty", name : "현용식", ratio: 0.4},
				{party: "undecided", name : "-", ratio: 11.2},
			]
		},
		{
			"requester": "KBS",
			"research": "한국리서치",
			"period": "4월 6일 ~ 4월 8일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "송재호", ratio: 39.7},
				{party: "unitedfuture", name : "장성철", ratio: 33.2},
				{party: "justice21", name : "고병수", ratio: 6.1},
				{party: "ourrepublican", name : "문대탄", ratio: 0.8},
				{party: "noparty", name : "박희수", ratio: 5.3},
				{party: "noparty", name : "임효준", ratio: 1.3},
				{party: "noparty", name : "현용식", ratio: 0},
				{party: "undecided", name : "-", ratio: 13.6},
			]
		}
	],
	// 제주 제주을
	"2490102" : [
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오영훈", ratio: 51.2},
				{party: "unitedfuture", name : "부상일", ratio: 31.8},
				{party: "minjung", name : "강은주", ratio: 1.4},
				{party: "undecided", name : "-", ratio: 12.1},
			]
		},
		{
			"requester": "헤드라인제주, KCTV 제주방송, 제주일보, 제주투데이",
			"research": "한국갤럽",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 502,
			desc: "표본오차는 95% 신뢰수준에서 ±2.5%포인트(제주시 갑 ±4.4%포인트, 제주시을 ±4.4%포인트, 서귀포시 ±4.4%포인트)",
			link: "http://www.headlinejeju.co.kr/news/articleView.html?idxno=413395",
			data: [
				{party: "theminjoo", name : "오영훈", ratio: 49.9},
				{party: "unitedfuture", name : "부상일", ratio: 28.9},
				{party: "minjung", name : "강은주", ratio: 1.2},
				{party: "etcparty", name : "차주홍", ratio: 1.4},
				{party: "etcparty", name : "전윤영", ratio: 0.2},
				{party: "undecided", name : "-", ratio: 18.4},
			]
		},
		{
			"requester": "제민일보, 한라일보, JIBS",
			"research": "리얼미터",
			"period": "4월 3일 ~ 4월 4일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오영훈", ratio: 46.5},
				{party: "unitedfuture", name : "부상일", ratio: 36.8},
				{party: "minjung", name : "강은주", ratio: 2.9},
				{party: "etcparty", name : "차주홍", ratio: 1.6},
				{party: "etcparty", name : "전윤영", ratio: 0.5},
				{party: "undecided", name : "-", ratio: 11.7},
			]
		},
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "오영훈", ratio: 54.1},
				{party: "unitedfuture", name : "부상일", ratio: 33.4},
				{party: "minjung", name : "강은주", ratio: 2.9},
				{party: "etcparty", name : "차주홍", ratio: 1.4},
				{party: "etcparty", name : "전윤영", ratio: 0.3},
				{party: "undecided", name : "-", ratio: 7.8},
			]
		}
	],
	// 제주 서귀포
	"2490201" : [
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리 의뢰",
			"research": "코리아리서치인터내셔널",
			"period": "3월 16일 ~ 3월 17일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "위성곤", ratio: 48.6},
				{party: "unitedfuture", name : "강경필", ratio: 35.0},
				{party: "undecided", name : "-", ratio: 11.9},
			]
		},
		{
			"requester": "헤드라인제주, KCTV 제주방송, 제주일보, 제주투데이",
			"research": "한국갤럽",
			"period": "3월 28일 ~ 3월 29일",
			"respondent": 507,
			desc: "표본오차는 95% 신뢰수준에서 ±2.5%포인트(제주시 갑 ±4.4%포인트, 제주시을 ±4.4%포인트, 서귀포시 ±4.4%포인트)",
			link: "http://www.headlinejeju.co.kr/news/articleView.html?idxno=413395",
			data: [
				{party: "theminjoo", name : "위성곤", ratio: 48.5},
				{party: "unitedfuture", name : "강경필", ratio: 29.3},
				{party: "etcparty", name : "문광삼", ratio: 1.0},
				{party: "undecided", name : "-", ratio: 21.2},
			]
		},
		{
			"requester": "제민일보, 한라일보, JIBS",
			"research": "리얼미터",
			"period": "4월 4일 ~ 4월 5일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "위성곤", ratio: 47.9},
				{party: "unitedfuture", name : "강경필", ratio: 36.3},
				{party: "etcparty", name : "문광삼", ratio: 1.8},
				{party: "undecided", name : "-", ratio: 14.1},
			]
		},
		{
			"requester": "제주MBC, 제주CBS, 제주신보, 제주의소리",
			"research": "코리아리서치인터내셔널",
			"period": "4월 6일 ~ 4월 7일",
			"respondent": 500,
			desc: "응답자수 미표기로 인해 500으로 처리",
			link: "https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C",
			data: [
				{party: "theminjoo", name : "위성곤", ratio: 54.8},
				{party: "unitedfuture", name : "강경필", ratio: 34.2},
				{party: "etcparty", name : "문광삼", ratio: 0.6},
				{party: "undecided", name : "-", ratio: 10.5},
			]
		}
	]
};
